<template>
  <div class="device-resident">
    <HeaderMenu/>
    <div class="container-fluid py-4">
      <div
        class="
          d-flex
          flex-column flex-sm-row
          align-items-center
          justify-content-between
        "
      >
        <h1 class="h5 fw-bold mb-3">{{ $t("__residentManagement") }}</h1>
        <div class="d-inline-flex flex-wrap">
          <button
            type="button"
            class="btn btn-gray me-3 mb-3 text-nowrap rounded-pill"
            @click="getResidents"
          >
            {{ $t('__refresh') }}
          </button>
          <button
            v-if="userInfo && userInfo.isMultiAgency === false"
            type="button"
            class="btn btn-primary me-3 mb-3 text-nowrap rounded-pill"
            @click="addModal"
          >
            {{ $t('__add') }}
          </button>
          <form @submit.prevent="searchResident">
            <div class="input-group rounded-pill mb-3">
              <input
                v-model="search"
                type="text"
                class="form-control rounded-pill"
                :placeholder="$t('__searchResidentName')"
                aria-label="search"
                aria-describedby="search"
              />
              <button
                type="submit"
                class="btn btn-link px-2 text-dark"
                id="search"
              >
                <i class="bi bi-search"></i>
              </button>
              <button
                v-if="filter"
                type="button"
                class="btn btn-primary px-3 ms-1 rounded-pill"
                id="clearSearch"
                @click="clearSearch"
              >
                {{ $t("__clearSearch") }}
              </button>
            </div>
          </form>
        </div>
      </div>
      <div class="card">
        <div class="card-body">
          <b-table
            responsive
            striped
            borderless
            head-variant="light"
            :empty-text="$t('__notData')"
            :empty-filtered-text="$t('__notFindResident')"
            :items="items"
            :fields="fields"
            :current-page="currentPage"
            :per-page="perPage"
            :filter="filter"
            :filter-included-fields="filterOn"
          >
            <template v-slot:head()="scope">
              <div class="text-nowrap">
                {{ scope.label }}
              </div>
            </template>
            <template v-slot:cell(gender)="data">
              {{
                data.item.gender === 1
                  ? $t('__male')
                  : data.item.gender === 2
                    ? $t('__female')
                    : 'N/A'
              }}
            </template>
            <template v-slot:cell(resident_type)="data">
              {{
                data.item.resident_type === '其他' && data.item.resident_type_other
                  ? `${data.item.resident_type} (${data.item.resident_type_other})`
                  : data.item.resident_type || '-'
              }}
            </template>
            <template v-slot:cell(notify_settings)="data">
              <div
                v-if="data.item.notify_setting"
                class="d-none d-sm-inline-block"
              >
                <span class="pe-3"
                      :style="{ 'opacity': data.item.notify_setting.has_push === 0 && data.item.notify_setting.has_line === 0 ? 0.4 : data.item.notify_setting.notify_lying ? 1 : 0.4 }"
                >
                  <img
                    class="align-bottom" style="width: 36px;"
                    src="@/assets/images/LYB.svg"
                    :alt="$t('__LYBNotifyText')"
                  />
                  <span class="ps-1">{{ $t('__LYBNotifyText') }}</span>
                </span>
                <span class="pe-3"
                      :style="{ 'opacity': data.item.notify_setting.notify_overbedding ? 1 : 0.4 }"
                >
                  <i class="bi bi-exclamation-triangle-fill align-bottom" style="font-size: 20px; color: #dc3545;"></i>
                  <span class="ps-1">過度躺床</span>
                </span>
                <span class="pe-3"
                      :style="{ 'opacity': data.item.notify_setting.has_push === 0 && data.item.notify_setting.has_line === 0 ? 0.4 : data.item.notify_setting.notify_leave && (data.item.notify_setting.notify_leave_action || data.item.notify_setting.notify_leave_timeout) ? 1 :  0.4 }"
                >
                  <img
                    class="align-bottom"
                    src="@/assets/images/LVB.svg"
                    :alt="$t('__leaveTheBed')"
                  />
                  <span class="ps-1">{{ $t('__leaveTheBed') }}</span>
                </span>
                <span class="pe-3"
                      :style="{ 'opacity': data.item.notify_setting.has_push === 0 && data.item.notify_setting.has_line === 0 ? 0.4 : data.item.notify_setting.notify_restless ? 1 :  0.4 }"
                >
                  <img
                    class="align-bottom pb-2"
                    src="@/assets/images/restless.svg"
                    :alt="$t('__restless')"
                  />
                  <span class="ps-1">{{ $t('__restless') }}</span>
                </span>
                <span class="pe-3"
                      :style="{ 'opacity': data.item.notify_setting.has_push === 0 && data.item.notify_setting.has_line === 0 ? 0.4 : data.item.notify_setting.notify_respiration ? 1 :  0.4 }"
                >
                  <img
                    class="align-bottom pb-2"
                    src="@/assets/images/rr.svg"
                    :alt="$t('__restless')"
                  />
                  <span class="ps-1">{{ $t('__RR') }}</span>
                </span>
                <span
                  v-if="data.item.device && (data.item.device.chiline_user !== null || data.item.device.heart_rate_enabled === true)"
                  class="pe-3"
                  :style="{ 'opacity': data.item.notify_setting.has_push === 0 && data.item.notify_setting.has_line === 0 ? 0.4 : data.item.notify_setting.notify_heartRate ? 1 :  0.4 }"
                >
                  <img
                    class="align-bottom pb-2"
                    style="width: 20px;"
                    src="@/assets/images/heart_rate.png"
                    :alt="$t('__heartRate')"
                  />
                  <span class="ps-1">{{ $t('__heartRate') }}</span>
                </span>
                <span v-if="data.item.device && data.item.device.chiline_user !== null" class="pe-3"
                      :style="{ 'opacity': data.item.notify_setting.has_push === 0 && data.item.notify_setting.has_line === 0 ? 0.4 : data.item.notify_setting.notify_spo2 ? 1 :  0.4 }"
                >
                  <img
                    class="align-bottom pb-2"
                    style="height: 25px;"
                    src="@/assets/images/spo2.png"
                    :alt="$t('__spo2')"
                  />
                  <span class="ps-1">{{ $t('__spo2') }}</span>
                </span>
                <span v-if="data.item.device && data.item.device.chiline_user !== null" class="pe-3"
                      :style="{ 'opacity': data.item.notify_setting.has_push === 0 && data.item.notify_setting.has_line === 0 ? 0.4 : data.item.notify_setting.notify_temp ? 1 :  0.4 }"
                >
                  <img
                    class="align-bottom pb-2"
                    style="height: 25px;"
                    src="@/assets/images/temp.png"
                    :alt="$t('__temp')"
                  />
                  <span class="ps-1">{{ $t('__temp') }}</span>
                </span>
              </div>
            </template>
            <template v-slot:cell(active)="data">
              <div class="d-flex">
                <span
                  data-bs-toggle="tooltip"
                  data-bs-placement="top"
                  :title="data.item.hasEditPermission ? $t('__notifySettings') : $t('__noPermission')"
                  class="d-inline-block"
                >
                  <button
                    @click="editModal(data.item.id)"
                    :disabled="!data.item.hasEditPermission"
                    type="button"
                    class="btn btn-link px-1 text-dark"
                    data-bs-toggle="tooltip"
                    data-bs-placement="top"
                    :title="$t('__edit')"
                  >
                    <i class="bi bi-pencil mx-1"></i>
                  </button>
                </span>
                <span
                  data-bs-toggle="tooltip"
                  data-bs-placement="top"
                  :title="data.item.hasEditPermission ? $t('__notifySettings') : $t('__noPermission')"
                  class="d-inline-block"
                >
                  <button
                    @click="showNotifyModal(data.item.id, data.item.device)"
                    :disabled="!data.item.hasEditPermission"
                    type="button"
                    class="btn btn-link px-1 text-dark"
                  >
                    <i class="bi bi-bell mx-1"></i>
                  </button>
                </span>
                <span
                  data-bs-toggle="tooltip"
                  data-bs-placement="top"
                  :title="data.item.hasEditPermission ? $t('__delete') : $t('__noPermission')"
                  class="d-inline-block"
                >
                  <button
                    v-if="!data.item.device && !data.item.length"
                    :disabled="!data.item.hasEditPermission"
                    type="button"
                    href=""
                    class="btn btn-link px-1 text-danger"
                    data-bs-toggle="tooltip"
                    data-bs-placement="top"
                    :title="$t('__delete')"
                    @click="deleteAlert(data.item.id)"
                  >
                    <i class="bi bi-trash"></i>
                  </button>
                </span>
              </div>
            </template>
          </b-table>
        </div>
      </div>
      <div class="row align-items-center mt-3" v-if="totalRows">
        <div class="col-sm col-12 text-right text-sm-left">
          {{
            $t('__paginationInfo', {
              startNub: currentPage == 1 ? 1 : perPage * (currentPage - 1) + 1,
              entNub: currentPage == 1
                ? totalRows > perPage
                  ? perPage
                  : totalRows
                : perPage * (currentPage - 1) + perPage > totalRows
                  ? totalRows
                  : perPage * (currentPage - 1) + perPage,
              sum: totalRows
            })
          }}
        </div>
        <div class="col-sm col-12">
          <b-pagination
            v-if="totalRows > perPage"
            v-model="currentPage"
            :total-rows="totalRows"
            :per-page="perPage"
            align="right"
            first-number
            last-number
            class="mb-sm-0 mb-3 mt-sm-0 mt-3 cms_main"
          ></b-pagination>
        </div>
      </div>
    </div>

    <div class="modal fade cms-style" tabindex="-1" id="modal" ref="modal">
      <div class="modal-dialog">
        <div class="modal-content">
          <form @submit.prevent="submitResidentForm">
            <div class="modal-header">
              <h5 class="modal-title fw-medium">
                {{ $t("__residentManagementSettings") }}
              </h5>
              <button
                type="button"
                class="btn-close btn-close-white"
                data-bs-dismiss="modal"
                aria-label="Close"
              ></button>
            </div>
            <div class="modal-body">
              <div class="row">
                <div class="col-md-6">
                  <div class="mb-3">
                    <label for="resident_name" class="form-label fw-medium">{{
                        $t('__residentName')
                      }}</label>
                    <input
                      v-model="editResidentForm.name"
                      type="text"
                      class="form-control"
                      :class="{
                        'is-invalid': validate && validate.msg.name
                      }"
                      id="resident_name"
                      required
                    />
                    <div
                      class="invalid-feedback"
                      v-if="validate && validate.msg.name"
                    >
                      <div
                        v-for="(msg, index) in validate.msg.name"
                        :key="'resident_name' + index"
                      >
                        {{ msg }}
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-md-6">
                  <label class="form-label fw-medium">{{
                      $t('__residentGender')
                    }}</label>
                  <div>
                    <div class="form-check form-check-inline">
                      <input
                        v-model="editResidentForm.gender"
                        class="form-check-input"
                        :class="{
                            'is-invalid':
                              validate && validate.msg.gender
                          }"
                        type="radio"
                        name="gender"
                        id="resident_gender_male"
                        value="1"
                        required
                      />
                      <label
                        class="form-check-label"
                        for="resident_gender_male"
                      >{{ $t('__male') }}</label
                      >
                      <div
                        class="invalid-feedback"
                        v-if="validate && validate.msg.gender"
                      >
                        <div
                          v-for="(msg, index) in validate.msg.gender"
                          :key="'gender' + index"
                        >
                          {{ msg }}
                        </div>
                      </div>
                    </div>
                    <div class="form-check form-check-inline">
                      <input
                        v-model="editResidentForm.gender"
                        class="form-check-input"
                        :class="{
                            'is-invalid':
                              validate && validate.msg.gender
                          }"
                        type="radio"
                        name="gender"
                        id="resident_gender_female"
                        value="2"
                        required
                      />
                      <label
                        class="form-check-label"
                        for="resident_gender_female"
                      >{{ $t('__female') }}</label
                      >
                      <div
                        class="invalid-feedback"
                        v-if="validate && validate.msg.gender"
                      >
                        <div
                          v-for="(msg, index) in validate.msg.gender"
                          :key="'gender' + index"
                        >
                          {{ msg }}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="mb-3">
                    <label for="resident_birthday" class="form-label fw-medium">{{
                        $t('__residentBirthday')
                      }}</label>
                    <input
                      v-model="editResidentForm.birthday"
                      type="date"
                      class="form-control"
                      :class="{
                        'is-invalid': validate && validate.msg.birthday
                      }"
                      id="resident_birthday"
                    />
                    <div
                      class="invalid-feedback"
                      v-if="validate && validate.msg.birthday"
                    >
                      <div
                        v-for="(msg, index) in validate.msg.birthday"
                        :key="'resident_birthday' + index"
                      >
                        {{ msg }}
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="mb-3">
                    <label for="idNumber" class="form-label fw-medium">{{
                        $t('__idNumber')
                      }}</label>
                    <input
                      v-model="editResidentForm.id_number"
                      type="text"
                      class="form-control"
                      :class="{
                        'is-invalid': validate && validate.msg.id_number
                      }"
                      id="idNumber"
                    />
                    <div
                      class="invalid-feedback"
                      v-if="validate && validate.msg.id_number"
                    >
                      <div
                        v-for="(msg, index) in validate.msg.id_number"
                        :key="'id_number' + index"
                      >
                        {{ msg }}
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col">
                  <div class="mb-3">
                    <label for="note" class="form-label fw-medium">{{
                        $t('__note')
                      }}</label>
                    <textarea
                      v-model="editResidentForm.note"
                      class="form-control"
                      :class="{
                        'is-invalid': validate && validate.msg.note
                      }"
                      id="note"
                      rows="3"
                    ></textarea>
                    <div
                      class="invalid-feedback"
                      v-if="validate && validate.msg.note"
                    >
                      <div
                        v-for="(msg, index) in validate.msg.note"
                        :key="'note' + index"
                      >
                        {{ msg }}
                      </div>
                    </div>
                  </div>

                  <div class="mb-3">
                    <label for="usage_venue" class="form-label fw-medium">使用場域</label>
                    <select
                      v-model="editResidentForm.usage_venue_select"
                      class="form-select"
                      id="usage_venue"
                      @change="onUsageVenueChange"
                    >
                      <option :value="null">請選擇</option>
                      <option value="醫院">醫院</option>
                      <option value="社區(輔具中心)">社區(輔具中心)</option>
                      <option value="社區(日照中心)">社區(日照中心)</option>
                      <option value="__custom__">自訂</option>
                    </select>
                    <input
                      v-if="editResidentForm.usage_venue_select === '__custom__'"
                      v-model="editResidentForm.usage_venue_custom"
                      type="text"
                      class="form-control mt-2"
                      placeholder="請輸入自訂場域"
                      maxlength="50"
                    />
                  </div>

                  <div class="mb-3">
                    <label for="resident_type" class="form-label fw-medium">住民類型</label>
                    <select
                      v-model="editResidentForm.resident_type"
                      class="form-select"
                      :class="{
                        'is-invalid': validate && validate.msg.resident_type
                      }"
                      id="resident_type"
                      @change="handleResidentTypeChange"
                    >
                      <option :value="null">請選擇</option>
                      <option value="獨居長者">獨居長者</option>
                      <option value="老老照顧">老老照顧</option>
                      <option value="看護照顧">看護照顧</option>
                      <option value="子女照顧">子女照顧</option>
                      <option value="其他">其他</option>
                    </select>
                    <div
                      class="invalid-feedback"
                      v-if="validate && validate.msg.resident_type"
                    >
                      <div
                        v-for="(msg, index) in validate.msg.resident_type"
                        :key="'resident_type' + index"
                      >
                        {{ msg }}
                      </div>
                    </div>
                    <input
                      v-if="editResidentForm.resident_type === '其他'"
                      v-model="editResidentForm.resident_type_other"
                      type="text"
                      class="form-control mt-2"
                      :class="{
                        'is-invalid': validate && validate.msg.resident_type_other
                      }"
                      placeholder="請輸入其他類型說明"
                    />
                    <div
                      class="invalid-feedback"
                      v-if="validate && validate.msg.resident_type_other"
                    >
                      <div
                        v-for="(msg, index) in validate.msg.resident_type_other"
                        :key="'resident_type_other' + index"
                      >
                        {{ msg }}
                      </div>
                    </div>
                  </div>

                  <!-- 緊急電話號碼顯示 -->
                  <div class="mb-3" v-if="emergencyCallNumbers && emergencyCallNumbers.length > 0">
                    <label class="form-label fw-medium">
                      <i class="bi bi-info-circle-fill text-info me-1"></i>
                      系統緊急通知來電號碼
                    </label>
                    <div class="alert alert-info py-2">
                      <small class="d-block mb-2">請將以下號碼加入通訊錄，以便識別緊急通知來電：</small>
                      <div class="d-flex flex-wrap gap-2">
                        <span v-for="(number, index) in emergencyCallNumbers"
                              :key="'emergency-number-' + index"
                              class="badge bg-primary">
                          {{ formatPhoneNumber(number) }}
                        </span>
                      </div>
                    </div>
                  </div>

                  <div class="mb-3">
                    <div v-for="(contact, i) in editResidentForm.emergency_contacts" :key="i" class="row align-items-center mb-2">
                      <div class="col">
                        <label class="form-label fw-medium">{{ $t('__emergencyContacts') + (i + 1) }}</label>
                        <input v-model="contact.name" type="text" class="form-control" :placeholder="$t('__emergencyContacts')">
                      </div>
                      <div class="col">
                        <label class="form-label fw-medium">{{ $t('__emergencyContactsPhone') }}</label>
                        <input
                          v-model="contact.phone"
                          type="tel"
                          class="form-control"
                          :placeholder="$t('__emergencyContactsPhone')"
                          pattern="[0-9]*"
                          @input="contact.phone = contact.phone.replace(/[^0-9]/g, '')"
                        />
                      </div>
<!--                      <div class="col-auto">-->
<!--                        <button type="button" class="btn btn-outline-danger btn-sm" @click="delEmergencyContact(i)" v-if="editResidentForm.emergency_contacts.length > 1">-->
<!--                          刪除-->
<!--                        </button>-->
<!--                      </div>-->

<!--                      <button-->
<!--                        type="button"-->
<!--                        v-if="editResidentForm.emergency_contacts.length > 1"-->
<!--                        class="btn-close me-2"-->
<!--                        @click="delEmergencyContact(i)">-->
<!--                      </button>-->
                    </div>
<!--                    <button type="button" class="btn btn-outline-primary rounded-pill mt-2" @click="addEmergencyContact" v-if="editResidentForm.emergency_contacts.length < 5">-->
<!--                      新增連絡人-->
<!--                    </button>-->
                  </div>
                </div>
              </div>
            </div>
            <div class="modal-footer">
              <button
                type="button"
                class="btn btn-outline-primary rounded-pill"
                data-bs-dismiss="modal"
              >
                {{ $t("__cancel") }}
              </button>
              <button type="submit" class="btn btn-primary rounded-pill">
                {{ $t("__save") }}
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>

    <!-- 刪除住民 -->
    <div class="modal fade" id="deleteModal" data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1" ref="deleteModal">
      <div class="modal-dialog modal-sm">
        <div class="modal-content">
          <div class="modal-header justify-content-center">
            <h5 class="modal-title">{{ $t("__deleteResident") }}</h5>
          </div>
          <div class="modal-body text-center">
            <p class="mb-0">{{ $t("__deleteResidentInfo") }}</p>
            <p class="mb-0 fs-5 py-2 fw-medium">【{{ editResidentForm.name }}】</p>
            <p class="mb-0">{{ $t("__resident") }}</p>
          </div>
          <div class="modal-footer justify-content-between">
            <button
              type="button"
              class="btn btn-outline-secondary rounded-pill"
              data-bs-dismiss="modal"
            >
              {{ $t("__cancel") }}
            </button>
            <button
              @click="deleteResident(edit_id)"
              type="button"
              class="btn btn-primary rounded-pill"
            >
              {{ $t("__confirm") }}
            </button>
          </div>
        </div>
      </div>
    </div>

    <!-- 通知設定 -->
    <div class="modal fade cms-style" tabindex="-1" id="notify" ref="notifyModal">
      <div v-if="notifyModalData" class="modal-dialog modal-lg">
        <div class="modal-content">
          <div class="modal-header pb-5">
            <div class="h4 modal-title fw-medium text-center">
              <span class="fs-6 d-block">
                {{ modalTitle.name }}
              </span>
              {{ $t("__notifySettings") }}
            </div>
            <button
              type="button"
              class="btn-close btn-close-white"
              data-bs-dismiss="modal"
              aria-label="Close"
            ></button>
          </div>
          <div class="modal-body">
            <div class="h5 fw-medium mb-3">
              {{ $t('__notifySettings') }}
            </div>
            <div v-if="!hasnotifyData" class="text-danger mb-3">
              {{ $t('__notifyIsNotSet') }}
            </div>
            <div class="custom-tab-check d-flex">
              <div class="form-check">
                <input
                  v-model="notifySettingType"
                  class="form-check-input"
                  type="radio"
                  name="notifySettingType"
                  value="custom"
                  id="notifySettingTypeCustom"
                />
                <label
                  class="form-check-label fw-medium"
                  for="notifySettingTypeCustom"
                >
                  {{ $t('__custom') }}
                </label>
              </div>
            </div>
            <div class="p-3 bg-white" v-if="notifySettingType === 'custom'">
              <div class="row align-items-center mb-3">
                <div class="col-lg-3 fw-medium mb-2 mb-lg-0">
                  {{ $t('__notifyMethod') }}
                </div>
                <div class="col-lg-9">
                  <div class="form-check form-check-inline">
                    <input
                      v-model="notifyModalData.has_push"
                      class="form-check-input"
                      type="checkbox"
                      id="has_push"
                    />
                    <label class="form-check-label" for="has_push">{{
                        $t('__push')
                      }}</label>
                  </div>
                  <div class="form-check form-check-inline">
                    <input
                      v-model="notifyModalData.has_line"
                      class="form-check-input"
                      type="checkbox"
                      id="has_line"
                    />
                    <label class="form-check-label" for="has_line">LINE</label>
                  </div>
                  <div v-if="notifyModalData.has_line" class="mt-2">
                    <div class="form-check">
                      <input
                        v-model="notifyModalData.notify_daily_sleep"
                        class="form-check-input"
                        type="checkbox"
                        id="notify_daily_sleep"
                        :true-value="1"
                        :false-value="0"
                      />
                      <label class="form-check-label" for="notify_daily_sleep">{{
                          $t('__notifyDailySleep')
                        }}</label>
                      <a
                        v-if="notifyModalData.notify_daily_sleep"
                        href="#"
                        class="ms-2 small"
                        @click.prevent="selectAllSleepItems('daily')"
                      >{{ $t('__selectAll') }}</a>
                    </div>
                    <div v-if="notifyModalData.notify_daily_sleep" class="ms-4 mb-2">
                      <div
                        v-for="item in dailySleepItemOptions"
                        :key="item.key"
                        class="form-check form-check-inline"
                      >
                        <input
                          v-model="notifyModalData.daily_sleep_items"
                          class="form-check-input"
                          type="checkbox"
                          :id="'daily_sleep_item_' + item.key"
                          :value="item.key"
                        />
                        <label class="form-check-label small" :for="'daily_sleep_item_' + item.key">{{
                            $t(item.label)
                          }}</label>
                      </div>
                    </div>
                    <div class="form-check">
                      <input
                        v-model="notifyModalData.notify_weekly_sleep"
                        class="form-check-input"
                        type="checkbox"
                        id="notify_weekly_sleep"
                        :true-value="1"
                        :false-value="0"
                      />
                      <label class="form-check-label" for="notify_weekly_sleep">{{
                          $t('__notifyWeeklySleep')
                        }}</label>
                      <a
                        v-if="notifyModalData.notify_weekly_sleep"
                        href="#"
                        class="ms-2 small"
                        @click.prevent="selectAllSleepItems('weekly')"
                      >{{ $t('__selectAll') }}</a>
                    </div>
                    <div v-if="notifyModalData.notify_weekly_sleep" class="ms-4 mb-2">
                      <div
                        v-for="item in weeklySleepItemOptions"
                        :key="item.key"
                        class="form-check form-check-inline"
                      >
                        <input
                          v-model="notifyModalData.weekly_sleep_items"
                          class="form-check-input"
                          type="checkbox"
                          :id="'weekly_sleep_item_' + item.key"
                          :value="item.key"
                        />
                        <label class="form-check-label small" :for="'weekly_sleep_item_' + item.key">{{
                            $t(item.label)
                          }}</label>
                      </div>
                    </div>
                    <div class="form-check">
                      <input
                        v-model="notifyModalData.notify_daily_report"
                        class="form-check-input"
                        type="checkbox"
                        id="notify_daily_report"
                        :true-value="1"
                        :false-value="0"
                      />
                      <label class="form-check-label" for="notify_daily_report">{{
                          $t('__notifyDailyReport')
                        }}</label>
                    </div>
                  </div>
                </div>
              </div>
              <div class="row align-items-top mb-3">
                <div class="col-lg-3 fw-medium mb-2 mb-lg-0">
                  {{ $t('__excludeRange') }}
                </div>
                <div class="col-lg-9">
                  <div class="form-check">
                    <input
                      class="form-check-input"
                      type="checkbox"
                      id="has_exclude"
                      v-model="notifyModalData.has_exclude"
                    />
                    <label class="form-check-label" for="has_exclude">{{ $t('__enableNotifySchedule') }}</label>
                  </div>

                  <small class="text-danger d-block mt-1" v-if="notifyModalData.has_exclude" >
                    {{ $t('__excludeRangeNote') }}
                  </small>
                  <small class="text-danger d-block mt-1" v-if="notifyModalData.has_exclude" >
                    {{ $t('__excludeRangeTypeNote') }}
                  </small>

                  <div v-if="notifyModalData.has_exclude" class="pt-3">
                    <div
                      v-for="(excludeTime, index) in notifyModalData.exclude_range"
                      :key="'excludeTime' + index"
                      class="row p-3 g-1 align-items-center"
                      :class="{ 'bg-light': index % 2 === 0 }"
                    >
                      <!-- 時間 picker -->
                      <div class="col d-flex align-items-center mt-2 mt-lg-0">
                        <VueCtkDateTimePicker
                          :label="$t('__startTime')"
                          v-model="excludeTime.started_at"
                          only-time
                          format="HH:mm"
                          formatted="HH:mm"
                          right
                          color="#2CBDC0"
                          button-color="#2CBDC0"
                          :id="'excludeTimeStart_at' + index"
                        />
                        <span class="px-1">-</span>
                        <VueCtkDateTimePicker
                          :label="$t('__entTime')"
                          v-model="excludeTime.ended_at"
                          only-time
                          format="HH:mm"
                          formatted="HH:mm"
                          right
                          color="#2CBDC0"
                          button-color="#2CBDC0"
                          :id="'excludeTimeEnd_at' + index"
                        />
                      </div>

                      <!-- 三個 checkbox -->
                      <div class="col-md-6">
                        <div class="form-check form-check-inline">
                          <input
                            class="form-check-input"
                            type="checkbox"
                            :id="'leave_'+index"
                            v-model="excludeTime.apply_leave"
                            true-value="1" false-value="0"
                          />
                          <label class="form-check-label" :for="'leave_'+index">
                            {{ $t('__leaveTheBed') }}
                          </label>
                        </div>
                        <div class="form-check form-check-inline">
                          <input
                            class="form-check-input"
                            type="checkbox"
                            :id="'lying_'+index"
                            v-model="excludeTime.apply_lying"
                            true-value="1" false-value="0"
                          />
                          <label class="form-check-label" :for="'lying_'+index">
                            {{ $t('__LYBNotifyText') }}
                          </label>
                        </div>
                        <div class="form-check form-check-inline">
                          <input
                            class="form-check-input"
                            type="checkbox"
                            :id="'restless_'+index"
                            v-model="excludeTime.apply_restless"
                            true-value="1" false-value="0"
                          />
                          <label class="form-check-label" :for="'restless_'+index">
                            {{ $t('__restless') }}
                          </label>
                        </div>
                      </div>

                      <div class="col-auto mt-2 mt-lg-0">
                        <button
                          type="button"
                          class="btn-close"
                          @click="delExcludeTime(index)"
                        ></button>
                      </div>
                    </div>
                  </div>
                  <div class="text-end mt-2">
                    <button
                      v-if="
                        notifySettingType === 'custom' &&
                          notifyModalData.exclude_range.length < 5 &&
                          notifyModalData.has_exclude
                      "
                      class="btn btn-outline-primary rounded-pill"
                      @click="addExcludeTime"
                    >
                      {{ $t('__addExcludeTime') }}
                    </button>
                  </div>
                </div>
              </div>
              <div class="row align-items-top mb-3">
                <div class="col-lg-3 fw-medium mb-2 mb-lg-0">
                  {{ $t('__otherConditions') }}
                </div>
                <div class="col-lg-9">
                  <div
                    class="
                      form-check
                      d-flex
                      align-items-top align-items-sm-center
                      mb-3
                    "
                  >
                    <input
                      class="form-check-input me-2"
                      type="checkbox"
                      id="has_silent_notify"
                      v-model="notifyModalData.has_silent_notify"
                    />
                    <label
                      class="form-check-label align-items-center"
                      for="has_silent_notify"
                    >
                      {{ $t('__afterNotification') }}
                      <span class="d-block d-sm-inline-block">
                        <input
                          :value="
                            secondsToMinutes(
                              notifyModalData.silent_notify_timeout
                            )
                          "
                          @change="
                            notifyModalData.silent_notify_timeout = minutesToSeconds(
                              $event.target.value
                            )
                          "
                          type="number"
                          class="
                            form-control
                            d-inline-block
                            mx-sm-2
                            me-2
                            mt-sm-0 mt-2
                          "
                          style="width: 100px"
                        />
                        {{ $t('__minutesLaterStartAgain') }}
                      </span>
                    </label>
                  </div>
                  <div
                    class="
                      form-check
                      d-flex
                      align-items-top align-items-sm-center
                      mb-3
                    "
                  >
                    <input
                      class="form-check-input me-2"
                      type="checkbox"
                      id="has_silent_bed"
                      v-model="notifyModalData.has_silent_bed"
                    />
                    <label
                      class="form-check-label align-items-center"
                      for="has_silent_bed"
                    >
                      {{ $t('__backToBed') }}
                      <span class="d-block d-sm-inline-block">
                        <input
                          :value="
                            secondsToMinutes(notifyModalData.silent_bed_timeout)
                          "
                          @change="
                            notifyModalData.silent_bed_timeout = minutesToSeconds(
                              $event.target.value
                            )
                          "
                          type="number"
                          class="
                            form-control
                            d-inline-block
                            mx-sm-2
                            me-2
                            mt-sm-0 mt-2
                          "
                          style="width: 100px"
                        />
                        {{ $t('__withinMinutesWithoutNotification') }}
                      </span>
                    </label>
                  </div>
                </div>
              </div>

              <div class=" d-flex flex-column flex-md-row cms-style side-tab">
                <div class="left-col" style="flex-shrink: 0;">
                  <ul class="list-group flex-md-column flex-row" ref="customList">
                    <li class="list-group-item">
                      <button
                        class="btn btn-link nav-link fw-medium"
                        id="home-tab"
                        data-bs-toggle="tab"
                        data-bs-target="#LVBStatistics"
                        type="button"
                        role="tab"
                        aria-controls="LVBStatistics"
                        aria-selected="true"
                      >
                        {{ $t('__LVBNotify') }}
                      </button>
                    </li>
                    <li class="list-group-item">
                      <button
                        class="btn btn-link nav-link fw-medium"
                        id="home-tab"
                        data-bs-toggle="tab"
                        data-bs-target="#LYBStatistics"
                        type="button"
                        role="tab"
                        aria-controls="LYBStatistics"
                        aria-selected="true"
                      >
                        {{ $t('__LYBNotify') }}
                      </button>
                    </li>
                    <li class="list-group-item">
                      <button
                        class="btn btn-link nav-link fw-medium"
                        data-bs-toggle="tab"
                        data-bs-target="#OBDStatistics"
                        type="button"
                        role="tab"
                        aria-controls="OBDStatistics"
                        aria-selected="false"
                      >
                        過度躺床
                      </button>
                    </li>
                    <li class="list-group-item">
                      <button
                        class="btn btn-link nav-link fw-medium"
                        id="home-tab"
                        data-bs-toggle="tab"
                        data-bs-target="#RRNotifyStatistics"
                        type="button"
                        role="tab"
                        aria-controls="RRNotifyStatistics"
                        aria-selected="true"
                      >
                        {{ $t('__RRNotify') }}
                      </button>
                    </li>
                    <li class="list-group-item">
                      <button
                        class="btn btn-link nav-link fw-medium"
                        id="home-tab"
                        data-bs-toggle="tab"
                        data-bs-target="#restlessNotifyStatistics"
                        type="button"
                        role="tab"
                        aria-controls="restlessNotifyStatistics"
                        aria-selected="true"
                      >
                        {{ $t("__restlessNotify") }}
                      </button>
                    </li>
                    <li class="list-group-item"
                        v-if="notifyModalData.heartRateEnabled === true">
                      <button
                        class="btn btn-link nav-link fw-medium"
                        id="home-tab"
                        data-bs-toggle="tab"
                        data-bs-target="#heartRateNotifyStatistics"
                        type="button"
                        role="tab"
                        aria-controls="heartRateNotifyStatistics"
                        aria-selected="true"
                      >
                        {{ $t("__heartRateNotify") }}
                      </button>
                    </li>
                    <li class="list-group-item">
                      <button
                        class="btn btn-link nav-link fw-medium"
                        id="home-tab"
                        data-bs-toggle="tab"
                        data-bs-target="#comboNotifyStatistics"
                        type="button"
                        role="tab"
                        aria-controls="comboNotifyStatistics"
                        aria-selected="true"
                      >
                        {{ $t("__comboNotify") }}
                      </button>
                    </li>
                    <li class="list-group-item">
                      <button
                        class="btn btn-link nav-link fw-medium"
                        data-bs-toggle="tab"
                        data-bs-target="#callDialSettings"
                        type="button"
                        role="tab"
                        aria-controls="callDialSettings"
                        aria-selected="false"
                      >
                        {{ $t('__callDialSettings') }}
                      </button>
                    </li>
                  </ul>
                </div>

                <div class="right-col flex-fill">
                  <div class="tab-content cms-style h-100">
                    <div
                      class="tab-pane fade h-100"
                      id="LVBStatistics"
                      role="tabpanel"
                      aria-labelledby="LVBStatistics-tab"
                    >
                      <div class="px-3 px-md-5 py-3">
                        <div class="row">
                          <div class="col-md-3 fw-medium mb-2 mb-md-0">
                            {{ $t('__status') }}
                          </div>
                          <div class="col-md-9">
                            <div class="form-check form-switch d-flex align-items-center mb-3">
                              <input
                                v-model="notifyModalData.notify_leave"
                                class="form-check-input me-2 rounded-pill"
                                type="checkbox"
                                id="notify_leave"
                              />
                              <label class="form-check-label" for="notify_leave">
                                {{ $t('__enable') }}
                              </label>
                            </div>
                            <div class="d-flex align-items-center mb-3" v-if="notifyModalData.notify_leave">
                              <label class="me-2">{{ $t('__callCategory') }}</label>
                              <select v-model="notifyModalData.notify_leave_call_category" class="form-select form-select-sm" style="width: 120px;">
                                <option value="immediate">{{ $t('__callImmediate') }}</option>
                                <option value="deferred">{{ $t('__callDeferred') }}</option>
                              </select>
                            </div>
                          </div>
                        </div>

                        <!-- 離床 -->
                        <div class="row" v-if="notifyModalData.notify_leave">
                          <div class="col-md-3 fw-medium">{{ $t('__notifyConditions') }}</div>
                          <div class="col-md-9">
                            <div class="form-check d-flex align-items-center mb-3">
                              <input
                                v-model="notifyModalData.notify_leave_action"
                                class="form-check-input me-2"
                                type="checkbox"
                                id="notify_leave_action"
                              />
                              <label
                                class="form-check-label"
                                for="notify_leave_action"
                              >
                                {{ $t('__leaveTheBed') }}
                              </label>
                            </div>

                            <div class="form-check d-flex align-items-center justify-content-between mb-3">
                              <div class="d-flex align-items-center">
                                <input
                                  v-model="notifyModalData.notify_leave_warning"
                                  class="form-check-input me-2"
                                  type="checkbox"
                                  id="notify_leave_warning"
                                />
                                <label
                                  class="form-check-label"
                                  for="notify_leave_warning"
                                >
                                  {{ $t('__notify_leave_warning') }}
                                </label>
                              </div>
                              <!-- 通知等級 -->
                              <div class="d-flex align-items-center">
                                <input
                                  type="checkbox"
                                  id="notify_leave_warning_emergency"
                                  class="form-check-input"
                                  @click="handleLeaveWarningEmergency"
                                  :checked="notifyModalData.notify_leave_warning_type === 'emergency'"
                                  style="accent-color: #dc3545;"
                                />
                                <label class="ms-1" style="user-select:none;">
                                  {{ $t('__emergency') }}
                                </label>
                              </div>
                            </div>

                            <div class="form-check d-flex align-items-center justify-content-between mb-3">
                              <div class="d-flex align-items-center">
                                <input
                                  v-model="notifyModalData.notify_sitting_insufficient"
                                  class="form-check-input me-2"
                                  type="checkbox"
                                  id="notify_sitting_insufficient"
                                />
                                <label
                                  class="form-check-label"
                                  for="notify_sitting_insufficient"
                                >
                                  {{ $t('__notify_sitting_insufficient') }}
                                </label>
                              </div>
                              <!-- 通知等級 -->
                              <div class="d-flex align-items-center">
                                <input
                                  type="checkbox"
                                  id="notify_sitting_insufficient_emergency"
                                  class="form-check-input"
                                  @click="handleSittingInsufficientEmergency"
                                  :checked="notifyModalData.notify_sitting_insufficient_type === 'emergency'"
                                  style="accent-color: #dc3545;"
                                />
                                <label class="ms-1" style="user-select:none;">
                                  {{ $t('__emergency') }}
                                </label>
                              </div>
                            </div>

                            <!-- 坐姿檢查參數設定 -->
                            <div class="bg-light p-3 mb-4 rounded" v-if="notifyModalData.notify_sitting_insufficient">
                              <div class="mb-3">
                                <label class="form-check-label d-block mb-2">
                                  {{ $t('__sit_trigger_delay') }}
                                </label>
                                <Slider
                                  v-model.number="notifyModalData.sit_trigger_delay_seconds"
                                  :min="60"
                                  :max="7200"
                                  :format="SliderFormatMinute"
                                  :step="60"
                                />
                              </div>
                              <div>
                                <label class="form-check-label d-block mb-2">
                                  {{ $t('__sit_minimum_duration') }}
                                </label>
                                <Slider
                                  v-model.number="notifyModalData.sit_minimum_duration_seconds"
                                  :min="0"
                                  :max="600"
                                  :format="SliderFormatSecond"
                                  :step="10"
                                />
                              </div>
                            </div>

                            <div class="form-check d-flex align-items-center mb-5">
                              <input
                                v-model="notifyModalData.notify_leave_timeout"
                                class="form-check-input me-2"
                                type="checkbox"
                                id="notify_leave_timeout"
                                checked
                              />
                              <label class="form-check-label" for="notify_leave_timeout">
                                {{ $t('__leaveTheBedTimeOut') }}
                              </label>
                            </div>
                            <div
                              v-for="(c, i) in notifyModalData.notify_leave_conditions"
                              :key="i"
                              class="d-flex align-items-center mb-5"
                            >
                              <label :for="'lvb_action_'+i">{{ $t('__leaveTheBedTimeOut') }}</label>

                              <Slider
                                v-model.number="c.timeout_max"
                                :min="60"
                                :max="18000"
                                :format="SliderFormatMinuteMore"
                                :step="60"
                                class="mx-3 flex-fill"
                              />
                              <button
                                v-if="notifyModalData.notify_leave_conditions.length > 1"
                                class="btn-close"
                                @click="delNotifyLeaveCondition(i)">
                              </button>

                              <!-- 通知等級 -->
                              <div class="mx-3 d-flex align-items-center">
                                <input
                                  type="checkbox"
                                  :id="'notify_leave_emergency_'+i"
                                  class="form-check-input"
                                  @click="c.type = c.type === 'emergency' ? 'normal' : 'emergency'"
                                  :checked="c.type === 'emergency'"
                                  style="accent-color: #dc3545;"
                                />
                                <label class="ms-1" style="user-select:none;">
                                  {{ $t('__emergency') }}
                                </label>
                              </div>

                            </div>
                            <button
                              class="btn btn-outline-primary rounded-pill"
                              @click="addNotifyLeaveCondition"
                              v-if="notifyModalData.notify_leave_conditions.length < 5"
                            >
                              {{ $t('__addCondition') }}
                            </button>
                          </div>
                        </div>

                      </div>
                    </div>
                    <div
                      class="tab-pane fade h-100"
                      id="LYBStatistics"
                      role="tabpanel"
                      aria-labelledby="LVBStatistics-tab"
                    >
                      <div class="px-3 px-md-5 py-3">
                        <div class="row">
                          <div class="col-md-3 fw-medium mb-2 mb-md-0">
                            {{ $t('__status') }}
                          </div>
                          <div class="col-md-9">
                            <div
                              class="form-check form-switch d-flex align-items-center mb-3"
                            >
                              <input
                                v-model="notifyModalData.notify_lying"
                                class="form-check-input me-2 rounded-pill"
                                type="checkbox"
                                id="notify_lying"
                              />
                              <label class="form-check-label" for="notify_lying">
                                {{ $t('__enable') }}
                              </label>
                            </div>
                            <div class="d-flex align-items-center mb-3" v-if="notifyModalData.notify_lying">
                              <label class="me-2">{{ $t('__callCategory') }}</label>
                              <select v-model="notifyModalData.notify_lying_call_category" class="form-select form-select-sm" style="width: 120px;">
                                <option value="immediate">{{ $t('__callImmediate') }}</option>
                                <option value="deferred">{{ $t('__callDeferred') }}</option>
                              </select>
                            </div>
                          </div>
                        </div>

                        <!-- 躺床 -->
                        <div class="row" v-if="notifyModalData.notify_lying">
                          <div class="col-md-3 fw-medium">{{ $t('__notifyConditions') }}</div>
                          <div class="col-md-9">
                            <div
                              v-for="(c, i) in notifyModalData.notify_lying_conditions"
                              :key="i"
                              class="d-flex align-items-center mb-5"
                            >
                              <label class="me-2">{{ $t('__LYBTime') }}</label>

                              <Slider
                                v-model.number="c.max"
                                :min="3600"
                                :max="21600"
                                :format="SliderFormatMinuteMore"
                                :step="60"
                                class="flex-fill"
                              />
                              <button
                                v-if="notifyModalData.notify_lying_conditions.length > 1"
                                class="btn-close"
                                @click="delNotifyLyingCondition(i)">
                              </button>

                              <!-- 通知等級 -->
                              <div class="mx-3 d-flex align-items-center">
                                <input
                                  type="checkbox"
                                  :id="'notify_lying_emergency_'+i"
                                  class="form-check-input"
                                  @click="c.type = c.type === 'emergency' ? 'normal' : 'emergency'"
                                  :checked="c.type === 'emergency'"
                                  style="accent-color: #dc3545;"
                                />
                                <label class="ms-1" style="user-select:none;">
                                  {{ $t('__emergency') }}
                                </label>
                              </div>
                            </div>
                            <button
                              class="btn btn-outline-primary rounded-pill"
                              @click="addNotifyLyingCondition"
                              v-if="notifyModalData.notify_lying_conditions.length < 5"
                            >
                              {{ $t('__addCondition') }}
                            </button>
                          </div>
                        </div>

                      </div>
                    </div>
                    <!-- 過度躺床 -->
                    <div
                      class="tab-pane fade h-100"
                      id="OBDStatistics"
                      role="tabpanel"
                    >
                      <div class="px-3 px-md-5 py-3">
                        <div class="row">
                          <div class="col-md-3 fw-medium mb-2 mb-md-0">
                            {{ $t('__status') }}
                          </div>
                          <div class="col-md-9">
                            <div class="form-check form-switch d-flex align-items-center mb-3">
                              <input
                                v-model="notifyModalData.notify_overbedding"
                                class="form-check-input me-2 rounded-pill"
                                type="checkbox"
                                id="notify_overbedding"
                              />
                              <label class="form-check-label" for="notify_overbedding">
                                {{ $t('__enable') }}
                              </label>
                            </div>
                            <div class="d-flex align-items-center mb-3" v-if="notifyModalData.notify_overbedding">
                              <label class="me-2">{{ $t('__callCategory') }}</label>
                              <select v-model="notifyModalData.overbedding_call_category" class="form-select form-select-sm" style="width: 120px;">
                                <option value="immediate">{{ $t('__callImmediate') }}</option>
                                <option value="deferred">{{ $t('__callDeferred') }}</option>
                              </select>
                            </div>
                          </div>
                        </div>

                        <div v-if="notifyModalData.notify_overbedding">
                          <!-- 睡眠熱區模式 -->
                          <div class="row mb-3">
                            <div class="col-md-3 fw-medium">睡眠熱區</div>
                            <div class="col-md-9">
                              <div class="form-check form-check-inline">
                                <input class="form-check-input" type="radio" v-model="notifyModalData.sleep_hotzone_mode" value="fixed" id="hotzone_fixed" @change="onSleepHotzoneModeChange('fixed')" />
                                <label class="form-check-label" for="hotzone_fixed">固定模式</label>
                              </div>
                              <div class="form-check form-check-inline">
                                <input class="form-check-input" type="radio" v-model="notifyModalData.sleep_hotzone_mode" value="dynamic" id="hotzone_dynamic" @change="onSleepHotzoneModeChange('dynamic')" />
                                <label class="form-check-label" for="hotzone_dynamic">動態模式</label>
                              </div>
                              <div class="text-muted small mt-1" v-if="notifyModalData.sleep_hotzone_mode === 'dynamic'">
                                系統每日自動計算過去 3~7 天的睡眠時間
                              </div>
                            </div>
                          </div>

                          <!-- 睡眠時間 -->
                          <div class="row mb-3">
                            <div class="col-md-3 fw-medium">睡眠時間</div>
                            <div class="col-md-9">
                              <div class="d-flex align-items-center">
                                <input type="time" v-model="notifyModalData.sleep_start" class="form-control" style="width: 140px" :disabled="notifyModalData.sleep_hotzone_mode === 'dynamic'" />
                                <span class="mx-2">~</span>
                                <input type="time" v-model="notifyModalData.sleep_end" class="form-control" style="width: 140px" :disabled="notifyModalData.sleep_hotzone_mode === 'dynamic'" />
                              </div>
                              <div class="text-muted small mt-1" v-if="notifyModalData.sleep_hotzone_mode === 'fixed'">
                                此時段內不偵測過度躺床
                              </div>
                              <template v-else>
                                <div class="small mt-1 text-muted" v-if="hotzoneLoading">
                                  <span class="spinner-border spinner-border-sm me-1" role="status"></span>
                                  計算中...
                                </div>
                                <div class="small mt-1" v-else-if="notifyModalData.sleep_start && notifyModalData.sleep_end && dynamicSleepTime.start" style="color: #0d6efd;">
                                  系統計算結果：{{ notifyModalData.sleep_start }} ~ {{ notifyModalData.sleep_end }}，此時段內不偵測
                                </div>
                                <div class="small mt-1 text-warning" v-else>
                                  系統尚未累積足夠資料，將採用機構預設時間
                                  <span v-if="institutionSleepTime.start">（{{ institutionSleepTime.start }} ~ {{ institutionSleepTime.end }}）</span>
                                </div>
                              </template>
                            </div>
                          </div>

                          <!-- 通知條件 -->
                          <div class="row">
                            <div class="col-md-3 fw-medium">{{ $t('__notifyConditions') }}</div>
                            <div class="col-md-9">
                              <div
                                v-for="(c, i) in notifyModalData.overbedding_conditions"
                                :key="i"
                                class="mb-5"
                              >
                                <div class="mb-2">
                                  <div class="form-check form-check-inline">
                                    <input class="form-check-input" type="radio" v-model="c.mode" value="accumulative" :id="'obd_accum_'+i" :name="'obd_mode_'+i" />
                                    <label class="form-check-label" :for="'obd_accum_'+i">累積在床時間</label>
                                  </div>
                                  <div class="form-check form-check-inline">
                                    <input class="form-check-input" type="radio" v-model="c.mode" value="continuous" :id="'obd_cont_'+i" :name="'obd_mode_'+i" />
                                    <label class="form-check-label" :for="'obd_cont_'+i">持續在床時間</label>
                                  </div>
                                </div>
                                <div class="d-flex align-items-center" style="margin-top: 35px;">
                                  <Slider
                                    v-model.number="c.max"
                                    :min="180"
                                    :max="10800"
                                    :format="SliderFormatMinuteMore"
                                    :step="60"
                                    class="flex-fill"
                                  />
                                  <button
                                    v-if="notifyModalData.overbedding_conditions.length > 1"
                                    class="btn-close ms-2"
                                    @click="delOverBeddingCondition(i)">
                                  </button>
                                  <div class="mx-3 d-flex align-items-center">
                                    <input
                                      type="checkbox"
                                      :id="'obd_emergency_'+i"
                                      class="form-check-input"
                                      @click="c.type = c.type === 'emergency' ? 'normal' : 'emergency'"
                                      :checked="c.type === 'emergency'"
                                      style="accent-color: #dc3545;"
                                    />
                                    <label class="ms-1" style="user-select:none;">
                                      {{ $t('__emergency') }}
                                    </label>
                                  </div>
                                  <div class="mx-3 d-flex align-items-center">
                                    <input
                                      type="checkbox"
                                      :id="'obd_notify_once_'+i"
                                      class="form-check-input"
                                      v-model="c.notify_once"
                                    />
                                    <label class="ms-1" :for="'obd_notify_once_'+i" style="user-select:none;">
                                      {{ $t('__overbedding_notify_once') }}
                                    </label>
                                  </div>
                                </div>
                              </div>
                              <button
                                class="btn btn-outline-primary rounded-pill"
                                @click="addOverBeddingCondition"
                                v-if="notifyModalData.overbedding_conditions.length < 5"
                              >
                                {{ $t('__addCondition') }}
                              </button>
                            </div>
                          </div>
                        </div>

                      </div>
                    </div>
                    <div
                      class="tab-pane fade h-100"
                      id="RRNotifyStatistics"
                      role="tabpanel"
                      aria-labelledby="LVBStatistics-tab"
                    >
                      <div class="px-3 px-md-5 py-3">
                        <div class="row">
                          <div class="col-md-3 fw-medium mb-2 mb-md-0">
                            {{ $t('__status') }}
                          </div>
                          <div class="col-md-5">
                            <div class="form-check form-switch d-flex align-items-center mb-3">
                              <input
                                v-model="notifyModalData.notify_respiration"
                                class="form-check-input me-2 rounded-pill"
                                type="checkbox"
                                id="notify_respiration"
                              />
                              <label
                                class="form-check-label"
                                for="notify_respiration"
                              >
                                {{ $t('__enable') }}
                              </label>
                            </div>
                            <div class="d-flex align-items-center mb-3" v-if="notifyModalData.notify_respiration">
                              <label class="me-2">{{ $t('__callCategory') }}</label>
                              <select v-model="notifyModalData.notify_respiration_call_category" class="form-select form-select-sm" style="width: 120px;">
                                <option value="immediate">{{ $t('__callImmediate') }}</option>
                                <option value="deferred">{{ $t('__callDeferred') }}</option>
                              </select>
                            </div>
                          </div>
                          <div class="col-md-4">
                            <label
                              v-if=notifyModalData.suggest_rr
                              class="form-check-label"
                            >
                              {{
                                $t('__rrValueSuggest') + ':' + notifyModalData.suggest_rr.min + '~' + notifyModalData.suggest_rr.max
                              }}
                            </label>
                          </div>
                        </div>

                        <!-- 呼吸率 -->
                        <div class="row" v-if="notifyModalData.notify_respiration">
                          <div class="col-md-3 fw-medium">{{ $t('__notifyConditions') }}</div>
                          <div class="col-md-9">
                            <div
                              v-for="(c, i) in notifyModalData.notify_respiration_conditions"
                              :key="i"
                              class="mb-5"
                            >
                              <div class="d-flex align-items-center mb-4">
                                <label class="me-2">{{ $t('__rrValue') }}</label>
                                <Slider
                                  :value="[c.min, c.max]"
                                  @update="val => changeSliderNotifyRespiration(i, val)"
                                  :min="1"
                                  :max="45"
                                  class="flex-fill"
                                />
                                <button
                                  v-if="notifyModalData.notify_respiration_conditions.length > 1"
                                  class="btn-close ms-2"
                                  @click="delNotifyRespirationCondition(i)">
                                </button>

                                <!-- 通知等級 -->
                                <div class="mx-3 d-flex align-items-center">
                                  <input
                                    type="checkbox"
                                    :id="'notify_respiration_emergency_'+i"
                                    class="form-check-input"
                                    @click="c.type = c.type === 'emergency' ? 'normal' : 'emergency'"
                                    :checked="c.type === 'emergency'"
                                    style="accent-color: #dc3545;"
                                  />
                                  <label class="ms-1" style="user-select:none;">
                                    {{ $t('__emergency') }}
                                  </label>
                                </div>
                              </div>
                              <div class="d-flex align-items-center">
                                <label class="me-2">{{ $t('__lastTime') }}</label>
                                <Slider
                                  v-model.number="c.duration"
                                  :min="60"
                                  :max="7200"
                                  :format="SliderFormatMinute"
                                  :step="60"
                                  class="flex-fill"
                                />
                              </div>
                            </div>
                            <button
                              class="btn btn-outline-primary rounded-pill"
                              @click="addNotifyRespirationCondition"
                              v-if="notifyModalData.notify_respiration_conditions.length < 5"
                            >
                              {{ $t('__addCondition') }}
                            </button>
                          </div>
                        </div>

                      </div>
                    </div>
                    <div
                      class="tab-pane fade h-100"
                      id="restlessNotifyStatistics"
                      role="tabpanel"
                      aria-labelledby="restlessNotifyStatistics-tab"
                    >
                      <div class="px-3 px-md-5 py-3">
                        <div class="row">
                          <div class="col-md-3 fw-medium mb-2 mb-md-0">
                            {{ $t("__status") }}
                          </div>
                          <div class="col-md-9">
                            <div class="form-check form-switch d-flex align-items-center mb-3">
                              <input
                                v-model="notifyModalData.notify_restless"
                                class="form-check-input me-2 rounded-pill"
                                type="checkbox"
                                id="notify_restless"
                              />
                              <label
                                class="form-check-label" for="notify_restless">
                                {{ $t("__enable") }}
                              </label>
                            </div>
                            <div class="d-flex align-items-center mb-3" v-if="notifyModalData.notify_restless">
                              <label class="me-2">{{ $t('__callCategory') }}</label>
                              <select v-model="notifyModalData.notify_restless_call_category" class="form-select form-select-sm" style="width: 120px;">
                                <option value="immediate">{{ $t('__callImmediate') }}</option>
                                <option value="deferred">{{ $t('__callDeferred') }}</option>
                              </select>
                            </div>
                          </div>
                        </div>

                        <!-- 體動 -->
                        <div class="row" v-if="notifyModalData.notify_restless">
                          <div class="col-md-3 fw-medium mb-2 mb-md-0">
                            {{ $t("__notifyConditions") }}
                          </div>
                          <div class="col-md-9">
                            <div
                              v-for="(c, i) in notifyModalData.notify_restless_conditions"
                              :key="i"
                              class="mb-5"
                            >
                              <div class="d-flex align-items-center mb-4">
                                <label class="me-2">{{ $t("__restlessnessValue") }}</label>
                                <Slider
                                  v-model.number="c.max"
                                  :min="0"
                                  :max="100"
                                  :format="SliderFormatMore"
                                  class="flex-fill"
                                />
                                <button
                                  v-if="notifyModalData.notify_restless_conditions.length > 1"
                                  class="btn-close ms-2"
                                  @click="delNotifyRestlessCondition(i)">
                                </button>

                                <!-- 通知等級 -->
                                <div class="mx-3 d-flex align-items-center">
                                  <input
                                    type="checkbox"
                                    :id="'notify_restless_emergency_'+i"
                                    class="form-check-input"
                                    @click="c.type = c.type === 'emergency' ? 'normal' : 'emergency'"
                                    :checked="c.type === 'emergency'"
                                    style="accent-color: #dc3545;"
                                  />
                                  <label class="ms-1" style="user-select:none;">
                                    {{ $t('__emergency') }}
                                  </label>
                                </div>

                              </div>
                              <div class="d-flex align-items-center">
                                <label class="me-2">{{ $t("__lastTime") }}</label>
                                <Slider
                                  v-model.number="c.duration"
                                  :min="60"
                                  :max="600"
                                  :format="SliderFormatMinute"
                                  :step="60"
                                  class="flex-fill"
                                />
                              </div>
                            </div>
                            <button
                              class="btn btn-outline-primary rounded-pill"
                              @click="addNotifyRestlessCondition"
                              v-if="notifyModalData.notify_restless_conditions.length < 5"
                            >
                              {{ $t("__addCondition") }}
                            </button>
                          </div>
                        </div>

                      </div>
                    </div>

                    <div class="tab-pane fade h-100" id="heartRateNotifyStatistics" role="tabpanel" aria-labelledby="heartRateNotifyStatistics-tab">
                      <div class="px-3 px-md-5 py-3">
                        <div class="row">
                          <div class="col-md-3 fw-medium mb-2 mb-md-0">
                            {{ $t('__status') }}
                          </div>
                          <div class="col-md-5">
                            <div class="form-check form-switch d-flex align-items-center mb-3">
                              <input
                                v-model="notifyModalData.notify_heartRate"
                                class="form-check-input me-2 rounded-pill"
                                type="checkbox"
                                role="switch"
                                id="notify_respiration"
                              />
                              <label
                                class="form-check-label"
                                for="notify_respiration"
                              >
                                {{ $t('__enable') }}
                              </label>
                            </div>
                            <div class="d-flex align-items-center mb-3" v-if="notifyModalData.notify_heartRate">
                              <label class="me-2">{{ $t('__callCategory') }}</label>
                              <select v-model="notifyModalData.notify_heartRate_call_category" class="form-select form-select-sm" style="width: 120px;">
                                <option value="immediate">{{ $t('__callImmediate') }}</option>
                                <option value="deferred">{{ $t('__callDeferred') }}</option>
                              </select>
                            </div>
                          </div>
                          <div class="col-md-4">
                            <label
                              v-if=notifyModalData.suggest_heartRate
                              class="form-check-label"
                            >
                              {{
                                $t('__heartRateValueSuggest') + ':' + notifyModalData.suggest_heartRate.min + '~' + notifyModalData.suggest_heartRate.max
                              }}
                            </label>
                          </div>
                        </div>

                        <!-- 心跳 -->
                        <div class="row" v-if="notifyModalData.notify_heartRate">
                          <div class="col-md-3 fw-medium mb-2 mb-md-0">
                            {{ $t('__notifyConditions') }}
                          </div>
                          <div class="col-md-9">
                            <div
                              v-for="(c, i) in notifyModalData.notify_heartRate_conditions"
                              :key="i"
                              class="mb-5"
                            >
                              <div class="d-flex align-items-center mb-4">
                                <label class="me-2">{{ $t('__heartRateValue') }}</label>
                                <Slider
                                  :value="[c.min, c.max]"
                                  @update="val => changeHeartRateCondition(i, val)"
                                  :min="20"
                                  :max="200"
                                  class="flex-fill"
                                />
                                <button
                                  v-if="notifyModalData.notify_heartRate_conditions.length > 1"
                                  class="btn-close ms-2"
                                  @click="delNotifyHeartRateCondition(i)">
                                </button>

                                <!-- 通知等級 -->
                                <div class="mx-3 d-flex align-items-center">
                                  <input
                                    type="checkbox"
                                    :id="'notify_heartRate_emergency_'+i"
                                    class="form-check-input"
                                    @click="c.type = c.type === 'emergency' ? 'normal' : 'emergency'"
                                    :checked="c.type === 'emergency'"
                                    style="accent-color: #dc3545;"
                                  />
                                  <label class="ms-1" style="user-select:none;">
                                    {{ $t('__emergency') }}
                                  </label>
                                </div>
                              </div>
                              <div class="d-flex align-items-center">
                                <label class="me-2">{{ $t('__lastTime') }}</label>
                                <Slider
                                  v-model.number="c.duration"
                                  :min="60"
                                  :max="12000"
                                  :format="SliderFormatMinute"
                                  :step="60"
                                  class="flex-fill"
                                />
                              </div>
                            </div>
                            <button
                              class="btn btn-outline-primary rounded-pill"
                              @click="addNotifyHeartRateCondition"
                              v-if="notifyModalData.notify_heartRate_conditions.length < 5"
                            >
                              {{ $t('__addCondition') }}
                            </button>
                          </div>
                        </div>

                      </div>
                    </div>

                    <!-- 綜合通知 -->
                    <div class="tab-pane fade h-100" id="comboNotifyStatistics" role="tabpanel" aria-labelledby="comboNotifyStatistics-tab">
                      <div class="px-3 px-md-5 py-3">
                        <div class="row">
                          <div class="col-md-3 fw-medium mb-2 mb-md-0">
                            {{ $t('__status') }}
                          </div>
                          <div class="col-md-5">
                            <div class="form-check form-switch d-flex align-items-center mb-3">
                              <input
                                v-model="notifyModalData.notify_combo"
                                class="form-check-input me-2 rounded-pill"
                                type="checkbox"
                                id="notify_combo"
                              />
                              <label
                                class="form-check-label"
                                for="notify_combo"
                              >
                                {{ $t('__enable') }}
                              </label>
                            </div>
                            <div class="d-flex align-items-center mb-3" v-if="notifyModalData.notify_combo">
                              <label class="me-2">{{ $t('__callCategory') }}</label>
                              <select v-model="notifyModalData.notify_combo_call_category" class="form-select form-select-sm" style="width: 120px;">
                                <option value="immediate">{{ $t('__callImmediate') }}</option>
                                <option value="deferred">{{ $t('__callDeferred') }}</option>
                              </select>
                            </div>
                          </div>

                        </div>

                        <!-- 綜合通知 -->
                        <div class="row" v-if="notifyModalData.notify_combo">
                          <div class="col-md-3 fw-medium mb-2 mb-md-0">
                            {{ $t('__notifyConditions') }}
                          </div>
                          <div class="col-md-9">
                            <div
                              v-for="(c, i) in notifyModalData.notify_combo_conditions" :key="c.key" class="mb-5">
                              <div class="d-flex align-items-center mb-5">
                                <!-- 啟動 -->
                                <div class="form-check me-3">
                                  <input
                                    class="form-check-input"
                                    type="checkbox"
                                    v-model="c.enabled"
                                    :id="'combo_enabled_'+i"
                                  />
                                  <label class="form-check-label" :for="'combo_enabled_'+i">
                                  </label>
                                </div>

                                <label class="me-2" v-html="c.label"></label>

                                <!-- 通知等級 -->
                                <div class="mx-3 d-flex align-items-center">
                                  <input
                                    type="checkbox"
                                    :id="'notify_combo_emergency_'+i"
                                    class="form-check-input"
                                    @click="c.type = c.type === 'emergency' ? 'normal' : 'emergency'"
                                    :checked="c.type === 'emergency'"
                                    style="accent-color: #dc3545;"
                                  />
                                  <label class="ms-1" style="user-select:none;">
                                    {{ $t('__emergency') }}
                                  </label>
                                </div>
                              </div>

                            </div>

                          </div>
                        </div>

                      </div>
                    </div>

                    <!-- 撥號設定 -->
                    <div class="tab-pane fade h-100" id="callDialSettings" role="tabpanel" aria-labelledby="callDialSettings-tab">
                      <div class="px-3 px-md-5 py-3">
                        <div class="row">
                          <div class="col-md-6">
                            <div class="border rounded p-3 mb-3">
                              <div class="fw-medium mb-2 text-danger">{{ $t('__callImmediate') }}</div>
                              <div class="mb-2 row align-items-center">
                                <label class="col-5 col-form-label">{{ $t('__callRetryCount') }}</label>
                                <div class="col-7">
                                  <input v-model.number="notifyModalData.call_immediate_max_attempts" type="number" class="form-control" min="1" max="10" />
                                </div>
                              </div>
                              <div class="mb-2 row align-items-center">
                                <label class="col-5 col-form-label">{{ $t('__callRetryInterval') }}</label>
                                <div class="col-7">
                                  <div class="input-group">
                                    <input v-model.number="notifyModalData.call_immediate_retry_interval" type="number" class="form-control" min="1" max="30" />
                                    <span class="input-group-text">{{ $t('__minutes') }}</span>
                                  </div>
                                </div>
                              </div>
                              <div class="mb-2 row align-items-center">
                                <label class="col-5 col-form-label">{{ $t('__callCooldown') }}</label>
                                <div class="col-7">
                                  <div class="input-group">
                                    <input v-model.number="notifyModalData.call_immediate_cooldown" type="number" class="form-control" min="1" max="60" />
                                    <span class="input-group-text">{{ $t('__minutes') }}</span>
                                  </div>
                                </div>
                              </div>
                              <div class="mb-2 row align-items-center">
                                <label class="col-5 col-form-label">{{ $t('__callDailyLimit') }}</label>
                                <div class="col-7">
                                  <input v-model.number="notifyModalData.call_immediate_daily_limit" type="number" class="form-control" min="1" max="50" />
                                </div>
                              </div>
                            </div>
                          </div>
                          <div class="col-md-6">
                            <div class="border rounded p-3 mb-3">
                              <div class="fw-medium mb-2 text-secondary">{{ $t('__callDeferred') }}</div>
                              <div class="mb-2 row align-items-center">
                                <label class="col-5 col-form-label">{{ $t('__callRetryCount') }}</label>
                                <div class="col-7">
                                  <input v-model.number="notifyModalData.call_deferred_max_attempts" type="number" class="form-control" min="1" max="10" />
                                </div>
                              </div>
                              <div class="mb-2 row align-items-center">
                                <label class="col-5 col-form-label">{{ $t('__callRetryInterval') }}</label>
                                <div class="col-7">
                                  <div class="input-group">
                                    <input v-model.number="notifyModalData.call_deferred_retry_interval" type="number" class="form-control" min="1" max="30" />
                                    <span class="input-group-text">{{ $t('__minutes') }}</span>
                                  </div>
                                </div>
                              </div>
                              <div class="mb-2 row align-items-center">
                                <label class="col-5 col-form-label">{{ $t('__callCooldown') }}</label>
                                <div class="col-7">
                                  <div class="input-group">
                                    <input v-model.number="notifyModalData.call_deferred_cooldown" type="number" class="form-control" min="1" max="60" />
                                    <span class="input-group-text">{{ $t('__minutes') }}</span>
                                  </div>
                                </div>
                              </div>
                              <div class="mb-2 row align-items-center">
                                <label class="col-5 col-form-label">{{ $t('__callDailyLimit') }}</label>
                                <div class="col-7">
                                  <input v-model.number="notifyModalData.call_deferred_daily_limit" type="number" class="form-control" min="1" max="50" />
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                  </div>
                </div>
              </div>
            </div>
            <div class="p-3 bg-white" v-else>
              <div class="row mb-3">
                <div class="col-lg-3 fw-medium mb-2 mb-lg-0">
                  {{ $t('__openThisSelectMenu') }}
                </div>
                <div class="col-lg-9">
                  <div class="row">
                    <div class="col">
                      <div class="input-group mb-2">
                        <select
                          class="form-select border-0"
                          v-model="notifySettingTypeID"
                        >
                          <option
                            v-for="item in notifySetting"
                            :key="item.id"
                            :value="item.id"
                          >
                            {{
                              item.is_template
                                ? $t('__' + item.name)
                                : item.name
                            }}
                          </option>
                        </select>
                        <button
                          class="btn btn-link p-2 text-dark"
                          data-bs-toggle="tooltip"
                          data-bs-placement="top"
                          :title="$t('__getTemplates')"
                          @click="getNotify"
                        >
                          <i class="bi bi-arrow-clockwise"></i>
                        </button>
                      </div>
                    </div>
                    <div class="col-auto">
                      <button
                        class="btn btn-danger me-2 mb-2"
                        @click="toEditThisTemplate(notifySettingTypeID)"
                      >
                        {{ $t('__editThisTemplate') }}
                      </button>
                      <button
                        class="btn btn-outline-danger mb-2"
                        @click="copyNotifyData"
                      >
                        {{ $t('__copyThisTemplateToCustom') }}
                      </button>
                    </div>
                  </div>
                </div>
              </div>
              <div class="row mb-3">
                <div class="col-lg-3 fw-medium mb-2 mb-lg-0">
                  {{ $t('__notifyMethod') }}
                </div>
                <div class="col-lg-9">
                  {{ notifyModalData.has_line ? 'LINE' : '' }}
                  <span
                    v-if="notifyModalData.has_line && notifyModalData.has_push"
                  >、</span
                  >
                  {{ notifyModalData.has_push ? $t('__push') : '' }}
                  <div v-if="notifyModalData.has_line">
                    <small
                      class="d-block text-danger"
                      v-if="LINEAuth && LINEAuth.length"
                    >{{
                        $t('__LINENotifyAuthorizedQuantity', {
                          qty: LINEAuth.length
                        })
                      }}</small
                    >
                    <small class="d-block text-danger" v-else>{{
                        $t('__LINENotifyAuthorizeNoAccount')
                      }}</small>
                  </div>
                </div>
              </div>
              <div class="row mb-3" v-if="notifyModalData.has_exclude">
                <div class="col-lg-3 fw-medium mb-2 mb-lg-0">
                  {{ $t('__excludeRange') }}
                </div>
                <div class="col-lg-9">
                  <small class="text-danger d-block mb-1">{{
                      $t('__excludeRangeNote')
                    }}</small>
                  <div
                    v-for="(excludeTime,
                    index) in notifyModalData.exclude_range"
                    :key="'excludeTime' + index"
                    class="p-3"
                    :class="{ 'bg-light': index % 2 === 0 }"
                  >
                    <span>{{
                        excludeTime.started_at + '-' + excludeTime.ended_at
                      }}</span>
                  </div>
                </div>
              </div>
              <div
                class="row mb-3 align-items-center"
                v-if="
                  notifyModalData.has_silent_bed ||
                    notifyModalData.has_silent_notify
                "
              >
                <div class="col-lg-3 fw-medium mb-2 mb-lg-0">
                  {{ $t('__otherConditions') }}
                </div>
                <div class="col-lg-9">
                  <div v-if="notifyModalData.has_silent_notify">
                    {{
                      $t('__afterNotificationInfo', {
                        nub: secondsToMinutes(
                          notifyModalData.silent_notify_timeout
                        )
                      })
                    }}
                  </div>
                  <div v-if="notifyModalData.has_silent_bed">
                    {{
                      $t('__backToBedInfo', {
                        nub: secondsToMinutes(
                          notifyModalData.silent_bed_timeout
                        )
                      })
                    }}
                  </div>
                </div>
              </div>
              <div
                class="
                  d-flex
                  flex-column flex-md-row
                  cms-style
                  side-tab
                "
              >
                <div class="left-col" style="flex-shrink: 0;">
                  <ul
                    class="list-group flex-md-column flex-row templateList"
                    ref="templateList"
                  >
                    <li
                      class="list-group-item"
                      v-if="notifyModalData.notify_leave"
                    >
                      <button
                        class="btn btn-link nav-link fw-medium"
                        id="home-tab"
                        data-bs-toggle="tab"
                        data-bs-target="#LVBStatistics"
                        type="button"
                        role="tab"
                        aria-controls="LVBStatistics"
                        aria-selected="true"
                      >
                        {{ $t('__LVBNotify') }}
                      </button>
                    </li>
                    <li
                      class="list-group-item"
                      v-if="notifyModalData.notify_lying"
                    >
                      <button
                        class="btn btn-link nav-link fw-medium"
                        id="home-tab"
                        data-bs-toggle="tab"
                        data-bs-target="#LYBStatistics"
                        type="button"
                        role="tab"
                        aria-controls="LYBStatistics"
                        aria-selected="true"
                      >
                        {{ $t('__LYBNotify') }}
                      </button>
                    </li>
                    <li
                      class="list-group-item"
                      v-if="notifyModalData.notify_respiration"
                    >
                      <button
                        class="btn btn-link nav-link fw-medium"
                        id="home-tab"
                        data-bs-toggle="tab"
                        data-bs-target="#RRNotifyStatistics"
                        type="button"
                        role="tab"
                        aria-controls="RRNotifyStatistics"
                        aria-selected="true"
                      >
                        {{ $t('__RRNotify') }}
                      </button>
                    </li>
                    <li
                      class="list-group-item"
                      v-if="notifyModalData.notify_restless"
                    >
                      <button
                        class="btn btn-link nav-link fw-medium"
                        id="home-tab"
                        data-bs-toggle="tab"
                        data-bs-target="#restlessNotifyStatistics"
                        type="button"
                        role="tab"
                        aria-controls="restlessNotifyStatistics"
                        aria-selected="true"
                      >
                        {{ $t("__restlessNotify") }}
                      </button>
                    </li>
                  </ul>
                </div>
                <div class="right-col flex-fill">
                  <div class="tab-content cms-style h-100">
                    <div
                      v-if="notifyModalData.notify_leave"
                      class="tab-pane fade h-100"
                      id="LVBStatistics"
                      role="tabpanel"
                      aria-labelledby="LVBStatistics-tab"
                    >
                      <div class="px-3 px-md-5 py-3">
                        <div class="row">
                          <div class="col-md-3 fw-medium mb-2 mb-md-0">
                            {{ $t('__notifyConditions') }}
                          </div>
                          <div class="col-md-9">
                            <div v-if="notifyModalData.notify_leave_action">
                              {{ $t('__leaveTheBed') }}
                            </div>
                            <div v-if="notifyModalData.notify_leave_warning">
                              {{ $t('__notify_leave_warning') }}
                            </div>
                            <div v-if="notifyModalData.notify_sitting_insufficient">
                              {{ $t('__notify_sitting_insufficient') }}
                            </div>
                            <div v-if="notifyModalData.notify_leave_timeout">
                              {{
                                $t('__leaveTheBedTimeOut') +
                                ' ' +
                                secondsToMinutes(
                                  notifyModalData.notify_leave_timeout_max
                                ) +
                                ' ' +
                                $t('__minute')
                              }}
                            </div>
                            <!-- <div v-if="notifyModalData.notify_leave_site">
                              {{
                                $t("__SIT") +
                                " " +
                                notifyModalData.notify_leave_site_max +
                                " " +
                                $("__second")
                              }}
                            </div> -->
                          </div>
                        </div>
                      </div>
                    </div>
                    <div
                      v-if="notifyModalData.notify_lying"
                      class="tab-pane fade h-100"
                      id="LYBStatistics"
                      role="tabpanel"
                      aria-labelledby="LVBStatistics-tab"
                    >
                      <div class="px-3 px-md-5 py-3">
                        <div class="row">
                          <div class="col-md-3 fw-medium mb-2 mb-md-0">
                            {{ $t('__notifyConditions') }}
                          </div>
                          <div class="col-md-9">
                            {{
                              $t('__LYBTime') +
                              ' > ' +
                              secondsToMinutes(
                                notifyModalData.notify_lying_max
                              ) +
                              ' ' +
                              $t('__minute')
                            }}
                          </div>
                        </div>
                      </div>
                    </div>
                    <div
                      v-if="notifyModalData.notify_respiration"
                      class="tab-pane fade h-100"
                      id="RRNotifyStatistics"
                      role="tabpanel"
                      aria-labelledby="LVBStatistics-tab"
                    >
                      <div class="px-3 px-md-5 py-3">
                        <div class="row">
                          <div class="col-md-3 fw-medium mb-2 mb-md-0">
                            {{ $t('__notifyConditions') }}
                          </div>
                          <div class="col-md-9">
                            <div>
                              {{
                                $t('__rrValue') +
                                ' &lt; ' +
                                sliderNotifyRespiration[0] +
                                '、 > ' +
                                sliderNotifyRespiration[1]
                              }}
                            </div>
                            <div>
                              {{
                                $t('__lastTime') +
                                ' ' +
                                secondsToMinutes(
                                  notifyModalData.notify_respiration_duration
                                ) +
                                ' ' +
                                $t('__minute')
                              }}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div
                      v-if="notifyModalData.notify_restless"
                      class="tab-pane fade h-100"
                      id="restlessNotifyStatistics"
                      role="tabpanel"
                      aria-labelledby="restlessNotifyStatistics-tab"
                    >
                      <div class="px-3 px-md-5 py-3">
                        <div class="row">
                          <div class="col-md-3 fw-medium mb-2 mb-md-0">
                            {{ $t("__notifyConditions") }}
                          </div>
                          <div class="col-md-9">
                            <div>
                              {{
                                $t("__restlessnessValue") +
                                " > " +
                                notifyModalData.notify_restless_max
                              }}
                            </div>
                            <div>
                              {{
                                $t("__lastTime") +
                                " " +
                                secondsToMinutes(
                                  notifyModalData.notify_restless_duration
                                ) +
                                " " +
                                $t("__minute")
                              }}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-outline-primary rounded-pill"
              data-bs-dismiss="modal"
            >
              {{ $t('__cancel') }}
            </button>
            <button
              type="button"
              class="btn btn-primary rounded-pill"
              @click="submitNotifyModal"
            >
              {{ $t('__save') }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import HeaderMenu from '@/components/layout/HeaderMenu.vue'
import Slider from '@vueform/slider/dist/slider.vue2.js'
import '@vueform/slider/themes/default.css'
import { Tooltip, Modal, Tab } from 'bootstrap'
import i18n from '@/lang/lang.js'
import VueCtkDateTimePicker from 'vue-ctk-date-time-picker'
import 'vue-ctk-date-time-picker/dist/vue-ctk-date-time-picker.css'
import { resident } from '@/http/api/resident.js'
import { notify } from '@/http/api/notify.js'
import { notifyTemplate } from '@/http/api/notifyTemplate.js'
import { dashboard } from '@/http/api/dashboard.js'
import { mapState, mapMutations, mapGetters } from 'vuex'

export default {
  name: 'ResidentManagement',
  components: { HeaderMenu, VueCtkDateTimePicker, Slider },
  data () {
    return {
      fields: [
        {
          key: 'name',
          label: i18n.t('__residentName'),
          class: 'align-middle',
          sortable: true
        },
        {
          key: 'gender',
          label: i18n.t('__residentGender'),
          class: 'align-middle'
        },
        {
          key: 'id_number',
          label: i18n.t('__idNumber'),
          class: 'align-middle',
          sortable: true
        },
        {
          key: 'age',
          label: i18n.t('__residentAge'),
          class: 'align-middle',
          sortable: true
        },
        {
          key: 'birthday',
          label: i18n.t('__residentBirthday'),
          class: 'align-middle'
        },
        {
          key: 'note',
          label: i18n.t('__note'),
          class: 'align-middle',
          sortable: true
        },
        {
          key: 'resident_type',
          label: '住民類型',
          class: 'align-middle',
          sortable: true
        },
        {
          key: 'notify_settings',
          label: i18n.t('__notifyMethod'),
          class: 'align-middle'
        },
        {
          key: 'active',
          label: i18n.t('__active'),
          tdClass: 'align-middle',
          class: 'align-middle'
        }
      ],
      items: null,
      filter: null,
      filterOn: ['name'],
      search: null,
      bootstrap_tooltip: null,
      currentPage: 1,
      perPage: 10,
      is_edit: false,
      editResidentId: null,
      bootstrap_modal: null,
      editResidentForm: {
        name: null,
        birthday: '',
        gender: null,
        id_number: null,
        note: null,
        usage_venue: null,
        usage_venue_select: null,
        usage_venue_custom: '',
        resident_type: null,
        resident_type_other: null,
        emergency_contacts: [{ name: '', phone: '' }, { name: '', phone: '' }]
      },
      validate: null,
      hasnotifyData: false,
      // 睡眠通知細項，順序即 LINE 訊息的顯示順序（與後端 NotifySetting 常數對齊）
      dailySleepItemOptions: [
        { key: 'bed_time', label: '__sleepItemBedTime' },
        { key: 'fell_asleep', label: '__sleepItemFellAsleep' },
        { key: 'tst', label: '__sleepItemTst' },
        { key: 'se', label: '__sleepItemSe' },
        { key: 'waso', label: '__sleepItemWaso' },
        { key: 'leave', label: '__sleepItemLeave' },
        { key: 'day_on_bed', label: '__sleepItemDayOnBed' }
      ],
      weeklySleepItemOptions: [
        { key: 'se', label: '__weeklyItemSe' },
        { key: 'sri', label: '__weeklyItemSri' },
        { key: 'wake_sd', label: '__weeklyItemWakeSd' },
        { key: 'jetlag', label: '__weeklyItemJetlag' },
        { key: 'avg_day_on_bed', label: '__weeklyItemAvgDayOnBed' }
      ],
      notifyModalData: {
        exclude_range: [],
        has_line: 0,
        has_push: 0,
        notify_daily_sleep: 0,
        notify_weekly_sleep: 0,
        notify_daily_report: 0,
        daily_sleep_items: ['bed_time', 'fell_asleep', 'tst', 'se', 'waso', 'leave', 'day_on_bed'],
        weekly_sleep_items: ['se', 'sri', 'wake_sd', 'jetlag', 'avg_day_on_bed'],
        has_exclude: 0,
        has_silent_bed: 0,
        silent_bed_timeout: 300,
        has_silent_notify: 0,
        silent_notify_timeout: 600,
        notify_leave: 0,
        notify_leave_action: 0,
        notify_leave_warning: 0,
        notify_leave_warning_type: 'normal',
        notify_sitting_insufficient: 0,
        notify_sitting_insufficient_type: 'normal',
        sit_trigger_delay_seconds: 60,
        sit_minimum_duration_seconds: 180,
        notify_leave_timeout: 15,
        notify_leave_timeout_max: 900,
        notify_leave_site: 0,
        notify_leave_site_max: 10,
        notify_overbedding: 0,
        overbedding_mode: 'continuous',
        overbedding_threshold_hours: 2.0,
        overbedding_conditions: [{ mode: 'continuous', max: 7200, type: 'normal', notify_once: false }],
        sleep_hotzone_mode: null,
        sleep_start: null,
        sleep_end: null,
        notify_lying: 0,
        notify_lying_max: 7800,
        notify_restless: 0,
        notify_restless_max: 60,
        notify_restless_duration: 300,
        notify_respiration: 0,
        notify_respiration_min: 12,
        notify_respiration_max: 26,
        notify_respiration_duration: 600,
        notify_heartRate: 0,
        notify_heartRate_min: 50,
        notify_heartRate_max: 100,
        notify_heartRate_duration: 600,
        notify_spo2: 0,
        notify_spo2_max: 94,
        notify_spo2_duration: 900,
        notify_temp: 0,
        notify_temp_min: 35,
        notify_temp_max: 39,
        notify_temp_duration: 1200,
        notify_leave_conditions: [{ action: true, timeout_max: 60 }],
        notify_lying_conditions: [{ max: 3600 }],
        notify_restless_conditions: [{
          max: 45,
          duration: 300
        }],
        notify_respiration_conditions: [{
          min: this.suggest_rr?.min || 1,
          max: this.suggest_rr?.max || 45,
          duration: 60
        }],
        notify_combo: 0,
        notify_combo_conditions: [
          { key: 'low_hr_low_rr', enabled: false, type: 'emergency', label: '心率 < 50次/分鐘<br />呼吸率 < 12次/分鐘，持續 1分鐘' },
          { key: 'low_hr_high_rr', enabled: false, type: 'emergency', label: '心率 < 50次/分鐘<br />呼吸率 > 26次/分鐘，持續 2分鐘' },
          { key: 'high_hr_low_rr', enabled: false, type: 'emergency', label: '心率 > 120次/分鐘<br />呼吸率 < 12次/分鐘，持續 2分鐘' },
          { key: 'high_hr_high_rr', enabled: false, type: 'emergency', label: '心率 > 120次/分鐘<br />呼吸率 > 26次/分鐘，持續 1分鐘' }
        ],
        heartRateEnabled: false,
        call_immediate_max_attempts: 3,
        call_immediate_retry_interval: 2,
        call_immediate_cooldown: 10,
        call_immediate_daily_limit: 10,
        call_deferred_max_attempts: 1,
        call_deferred_retry_interval: 2,
        call_deferred_cooldown: 10,
        call_deferred_daily_limit: 1,
        notify_leave_call_category: 'immediate',
        notify_lying_call_category: 'immediate',
        overbedding_call_category: 'immediate',
        notify_respiration_call_category: 'immediate',
        notify_restless_call_category: 'immediate',
        notify_heartRate_call_category: 'immediate',
        notify_combo_call_category: 'immediate'
      },
      modalTitle: {
        id: null,
        name: null
      },
      showNotifyResidentID: null,
      notifySettingType: 'custom', // template
      notifySettingTypeID: 1,
      notifySetting: null,
      bootstrap_template_tab: [],
      bootstrap_custom_tab: [],
      LINEAuth: null,
      emergencyCallNumbers: [], // 緊急電話號碼列表
      institutionSleepTime: { start: null, end: null },
      dynamicSleepTime: { start: null, end: null },
      hotzoneLoading: false,
      SliderFormatMore: val => {
        return i18n.t('__moreThanThe') + Math.round(val)
      },
      SliderFormatLess: val => {
        return i18n.t('__lessThan') + Math.round(val)
      },
      SliderFormatMinuteMore: val => {
        return (
          i18n.t('__moreThanThe') + Math.round(val / 60) + i18n.t('__minute')
        )
      },
      SliderFormatMinuteLess: val => {
        return i18n.t('__lessThan') + Math.round(val / 60) + i18n.t('__minute')
      },
      SliderFormatMinute: val => {
        return Math.round(val / 60) + i18n.t('__minute')
      },
      SliderFormatSecond: val => {
        return Math.round(val) + i18n.t('__second')
      },
      SliderFormatSecondLast: val => {
        return i18n.t('__last') + Math.round(val) + i18n.t('__second')
      }
    }
  },
  computed: {
    ...mapState(['token', 'userInfo', 'timezone']),
    ...mapGetters(['timeZoneOffset']),
    totalRows () {
      return this.items ? this.items.length : null
    },
    sliderNotifyRespiration () {
      if (this.notifyModalData) {
        return [
          this.notifyModalData.notify_respiration_min,
          this.notifyModalData.notify_respiration_max
        ]
      } else {
        return null
      }
    },
    sliderNotifyHeartRate () {
      if (this.notifyModalData) {
        return [
          this.notifyModalData.notify_heartRate_min,
          this.notifyModalData.notify_heartRate_max
        ]
      } else {
        return null
      }
    },
    sliderNotifyTemp () {
      if (this.notifyModalData) {
        return [
          this.notifyModalData.notify_temp_min,
          this.notifyModalData.notify_temp_max
        ]
      } else {
        return null
      }
    }
  },
  watch: {
    items () {
      this.initBootstrapTooltip()
    },
    item (data) {
      this.totalRows = data.length
    },
    userInfo () {
      this.getResidents()
      this.getNotify()
      this.getEmergencyCallNumbers()
      this.getInstitutionSleepTime()
    },
    notifySettingTypeID () {
      this.getNotifySetting()
    },
    'notifyModalData.has_line' (newVal) {
      if (!newVal) {
        this.notifyModalData.notify_daily_sleep = 0
        this.notifyModalData.notify_weekly_sleep = 0
      }
    },
    notifySettingType () {
      const vm = this
      vm.$nextTick(function () {
        vm.getNotifySetting()
        vm.initBootstrapTab()
        vm.initBootstrapTooltip()
      })
    },
    editResidentForm: {
      handler: function () {
        this.validate = null
      },
      deep: true
    },
    verifyClearRecord: {
      handler: function () {
        this.validate = null
      },
      deep: true
    },
    'notifyModalData.notify_leave_warning': {
      handler: function (val) {
        if (!val) {
          this.notifyModalData.notify_leave_warning_type = 'normal'
        }
      }
    },
    'notifyModalData.notify_sitting_insufficient': {
      handler: function (val) {
        if (!val) {
          this.notifyModalData.notify_sitting_insufficient_type = 'normal'
        }
      }
    }
  },
  methods: {
    ...mapMutations([
      'LoadingText',
      'Loading',
      'Loaded',
      'AlertsInfo',
      'Alerted'
    ]),
    getResidents (id) {
      const vm = this
      vm.Loading()
      resident.get(id, vm.token).then((res) => {
        if (res.status <= 201) {
          if (id) {
            for (var i = 0; i < vm.items.length; i++) {
              if (vm.items[i].id === res.data.data.id) { // 如果是指定住民id則只取得該住民資料
                vm.items[i].notify_setting = res.data.data.notify_setting
                break
              }
            }
          } else {
            // 取得所有住民資料
            vm.items = res.data.data.map(resident => {
              const hasEditPermission = vm.userInfo.agencyPermission[resident.agency_id] && vm.userInfo.agencyPermission[resident.agency_id].edit
              return { ...resident, hasEditPermission }
            })
          }
        } else {
          vm.AlertsInfo({
            state: 'error',
            title: i18n.t('__error'),
            info: res.data.errors.toString()
          })
          vm.Alerted()
        }
        vm.Loaded()
      })
    },
    searchResident () {
      this.filter = this.search
    },
    clearSearch () {
      this.filter = null
      this.search = null
    },
    clickNotifyLeave () {
      if (this.notifyModalData.notify_leave) {
        this.notifyModalData.notify_leave_action = 0
        this.notifyModalData.notify_leave_timeout = 0
      } else {
        this.notifyModalData.notify_leave_action = 1
        this.notifyModalData.notify_leave_timeout = 1
      }
    },
    getNotify () {
      const vm = this
      notifyTemplate.get('', vm.token).then(res => {
        if (res.status <= 201 && res.data.status === 'success') {
          const data = res.data.data
          let hasSettingID = false
          vm.notifySetting = []
          if (data.length) {
            data.forEach(item => {
              if (item.name) {
                vm.notifySetting.push(item)
                if (vm.notifySettingTypeID === item.id) {
                  hasSettingID = true
                }
              }
            })
            vm.notifySettingTypeID = hasSettingID
              ? vm.notifySettingTypeID
              : vm.notifySetting[0].id
          }
        } else {
          vm.AlertsInfo({
            state: 'error',
            title: i18n.t('__error'),
            info: res.data.errors.toString()
          })
          vm.Alerted()
        }
      })
    },
    getEmergencyCallNumbers () {
      console.log(123456789)
      const vm = this
      resident.getEmergencyNumbers(vm.token).then((res) => {
        if (res.status === 200 && res.data.status === 'success') {
          vm.emergencyCallNumbers = res.data.data.emergency_numbers || []
        }
      }).catch((error) => {
        console.error('Failed to get emergency numbers:', error)
      })
    },
    getInstitutionSleepTime () {
      const vm = this
      dashboard.getSleepingTime(vm.token).then(res => {
        if (res.status <= 201 && res.data.data) {
          vm.institutionSleepTime.start = res.data.data.start
          vm.institutionSleepTime.end = res.data.data.end
        }
      }).catch(() => {})
    },
    onSleepHotzoneModeChange (mode) {
      if (mode === 'dynamic') {
        this.fetchSleepHotzonePreview()
      } else if (mode === 'fixed') {
        if (this.institutionSleepTime.start) {
          this.notifyModalData.sleep_start = this.institutionSleepTime.start
        }
        if (this.institutionSleepTime.end) {
          this.notifyModalData.sleep_end = this.institutionSleepTime.end
        }
      }
    },
    fetchSleepHotzonePreview () {
      const vm = this
      const residentId = vm.showNotifyResidentID
      if (!residentId) return

      vm.hotzoneLoading = true
      vm.notifyModalData.sleep_start = null
      vm.notifyModalData.sleep_end = null

      notify.sleepHotzonePreview(residentId, vm.token).then(res => {
        if (res.data.status === 'success' && res.data.data) {
          const d = res.data.data
          vm.notifyModalData.sleep_start = d.sleep_start || null
          vm.notifyModalData.sleep_end = d.sleep_end || null
          vm.dynamicSleepTime.start = d.sleep_start || null
          vm.dynamicSleepTime.end = d.sleep_end || null
        }
      }).catch(() => {
        vm.notifyModalData.sleep_start = null
        vm.notifyModalData.sleep_end = null
      }).finally(() => {
        vm.hotzoneLoading = false
        if (!vm.notifyModalData.sleep_start && vm.institutionSleepTime.start) {
          vm.notifyModalData.sleep_start = vm.institutionSleepTime.start
        }
        if (!vm.notifyModalData.sleep_end && vm.institutionSleepTime.end) {
          vm.notifyModalData.sleep_end = vm.institutionSleepTime.end
        }
      })
    },
    getNotifySetting () {
      const vm = this
      if (vm.notifySettingType === 'template') {
        vm.notifySetting.forEach(item => {
          if (item.id === vm.notifySettingTypeID) vm.notifyModalData = vm.normalizeSleepItems(item)
        })
      }
    },
    showNotifyModal (id, device = null) {
      const vm = this

      async function getNotifyDate () {
        await vm.getNotify()
        vm.Loading()
        vm.showNotifyResidentID = id

        notify.get(id, vm.token).then(res => {
          if (res.status <= 201 && res.data.status === 'success') {
            const data = res.data.data.notify_setting
            if (data) {
              vm.hasnotifyData = true
              if (data.is_shared || data.is_template) {
                vm.notifySettingType = 'template'
                vm.notifySettingTypeID = data.id
                vm.getNotifySetting()
              } else {
                vm.notifySettingType = 'custom'

                const parsed = { ...vm.notifyModalData, ...data }
                if (!Array.isArray(parsed.exclude_range)) {
                  parsed.exclude_range = []
                }
                [
                  'exclude_range',
                  'notify_leave_conditions',
                  'notify_lying_conditions',
                  'notify_respiration_conditions',
                  'notify_restless_conditions',
                  'notify_heartRate_conditions',
                  'notify_spo2_conditions',
                  'notify_temp_conditions',
                  'notify_combo_conditions',
                  'overbedding_conditions'
                ].forEach(key => {
                  if (parsed[key] && typeof parsed[key] === 'string') {
                    try {
                      parsed[key] = JSON.parse(parsed[key])
                    } catch (e) {
                      console.warn(`解析 ${key} 失敗，設為空陣列`, e)
                      parsed[key] = []
                    }
                  }

                  // 補 type 欄位
                  if (Array.isArray(parsed[key])) {
                    parsed[key].forEach((c, idx) => {
                      if (c && typeof c === 'object' && !('type' in c)) {
                        c.type = 'emergency'
                      } else if (c && typeof c === 'object') {
                        // 強制修正型態與內容
                        c.type = String(c.type).toLowerCase()
                        if (c.type !== 'normal' && c.type !== 'emergency') {
                          c.type = 'emergency'
                        }
                      }
                    })
                  }
                })

                const backendArr = Array.isArray(parsed.notify_combo_conditions) ? parsed.notify_combo_conditions : []

                if (backendArr.length === 4) {
                  parsed.notify_combo_conditions = backendArr
                } else {
                  parsed.notify_combo_conditions = [
                    { key: 'low_hr_low_rr', enabled: false, type: 'emergency', label: '心率 < 50次/分鐘<br />呼吸率 < 12次/分鐘，持續 1分鐘' },
                    { key: 'low_hr_high_rr', enabled: false, type: 'emergency', label: '心率 < 50次/分鐘<br />呼吸率 > 26次/分鐘，持續 2分鐘' },
                    { key: 'high_hr_low_rr', enabled: false, type: 'emergency', label: '心率 > 120次/分鐘<br />呼吸率 < 12次/分鐘，持續 2分鐘' },
                    { key: 'high_hr_high_rr', enabled: false, type: 'emergency', label: '心率 > 120次/分鐘<br />呼吸率 > 26次/分鐘，持續 1分鐘' }
                  ]
                }

                // 開始檢查坐姿的延遲最小 1 分鐘，舊資料低於 1 分鐘一律顯示為 1 分鐘
                parsed.sit_trigger_delay_seconds = Math.max(
                  60,
                  Number(parsed.sit_trigger_delay_seconds) || 0
                )

                vm.notifyModalData = vm.normalizeSleepItems(parsed)
                vm.initConditions()

                vm.notifyModalData.heartRateEnabled = false
                if (device && device.heart_rate_enabled === true) {
                  vm.notifyModalData.heartRateEnabled = true
                }
              }
            } else {
              vm.hasnotifyData = false
              vm.notifySettingType = 'template'
              vm.getNotifySetting()
            }
            if (vm.notifyModalData.sleep_hotzone_mode === 'dynamic') {
              vm.dynamicSleepTime.start = vm.notifyModalData.sleep_start || null
              vm.dynamicSleepTime.end = vm.notifyModalData.sleep_end || null
            } else {
              vm.dynamicSleepTime = { start: null, end: null }
              if (!vm.notifyModalData.sleep_start && vm.institutionSleepTime.start) {
                vm.notifyModalData.sleep_start = vm.institutionSleepTime.start
              }
              if (!vm.notifyModalData.sleep_end && vm.institutionSleepTime.end) {
                vm.notifyModalData.sleep_end = vm.institutionSleepTime.end
              }
            }

            vm.modalTitle.id = res.data.data.id
            vm.modalTitle.name = res.data.data.name
            vm.$nextTick(() => {
              vm.bootstrap_modal = new Modal(vm.$refs.notifyModal)
              vm.bootstrap_modal.show()
              vm.initBootstrapTab()
              vm.initBootstrapTooltip()
            })
          } else {
            vm.AlertsInfo({
              state: 'error',
              title: i18n.t('__error'),
              info: res.data.errors.toString()
            })
            vm.Alerted()
          }
          vm.Loaded()
        })
      }

      getNotifyDate()
    },
    // 睡眠通知細項：後端回傳可能是 JSON 字串或缺欄位（模板／舊資料），一律正規化成陣列
    normalizeSleepItems (data) {
      const fix = (key, options) => {
        let value = data[key]
        if (typeof value === 'string') {
          try {
            value = JSON.parse(value)
          } catch (e) {
            value = null
          }
        }
        data[key] = Array.isArray(value) ? value : options.map(i => i.key)
      }
      fix('daily_sleep_items', this.dailySleepItemOptions)
      fix('weekly_sleep_items', this.weeklySleepItemOptions)
      return data
    },
    selectAllSleepItems (type) {
      if (type === 'daily') {
        this.notifyModalData.daily_sleep_items = this.dailySleepItemOptions.map(i => i.key)
      } else {
        this.notifyModalData.weekly_sleep_items = this.weeklySleepItemOptions.map(i => i.key)
      }
    },
    submitNotifyModal () {
      const vm = this
      if (vm.notifySettingType === 'template') {
        console.log('template')
        notify
          .useSharedNotify(
            vm.showNotifyResidentID,
            {
              id: vm.notifySettingTypeID
            },
            vm.token
          )
          .then(res => {
            if (res.status <= 201 && res.data.status === 'success') {
              vm.getResidents(vm.showNotifyResidentID)
              vm.AlertsInfo({
                state: 'success',
                title: i18n.t('__success'),
                info: i18n.t('__editSuccess')
              })
              vm.Alerted()
              vm.bootstrap_modal.hide()
            } else {
              vm.AlertsInfo({
                state: 'error',
                title: i18n.t('__error'),
                info: res.data.errMsg.toString()
              })
              vm.Alerted()
              vm.validate = res.data.validate
            }
            vm.Loaded()
          })
      } else {
        delete vm.notifyModalData.agency_id
        delete vm.notifyModalData.created_at
        delete vm.notifyModalData.is_shared
        delete vm.notifyModalData.is_template
        delete vm.notifyModalData.name
        delete vm.notifyModalData.updated_at
        if (vm.notifyModalData.notify_restless_duration < 60) {
          vm.notifyModalData.notify_restless_duration = 60
        }
        vm.notifyModalData.sit_trigger_delay_seconds = Math.max(
          60,
          Number(vm.notifyModalData.sit_trigger_delay_seconds) || 0
        )
        if (Array.isArray(vm.notifyModalData.overbedding_conditions) && vm.notifyModalData.overbedding_conditions.length > 0) {
          vm.notifyModalData.overbedding_conditions.forEach(c => {
            c.max = Math.max(c.max || 7200, 180)
          })
          const first = vm.notifyModalData.overbedding_conditions[0]
          vm.notifyModalData.overbedding_mode = first.mode || 'continuous'
          vm.notifyModalData.overbedding_threshold_hours = first.max / 3600
        }
        notify
          .useCustomNotify(vm.showNotifyResidentID, vm.notifyModalData, vm.token)
          .then(res => {
            if (res.status <= 201 && res.data.status === 'success') {
              vm.getResidents(vm.showNotifyResidentID)
              vm.AlertsInfo({
                state: 'success',
                title: i18n.t('__success'),
                info: i18n.t('__editSuccess')
              })
              vm.Alerted()
              vm.bootstrap_modal.hide()
            } else {
              vm.AlertsInfo({
                state: 'error',
                title: i18n.t('__error'),
                info: res.data.errMsg.toString()
              })
              vm.Alerted()
              vm.validate = res.data.validate
            }
            vm.Loaded()
          })
      }
    },
    copyNotifyData () {
      const vm = this
      vm.notifySetting.forEach(item => {
        if (item.id === vm.notifySettingTypeID) {
          vm.notifyModalData = vm.normalizeSleepItems(item)
          delete vm.notifyModalData.id
        }
      })
      // 樣板整包替換後補齊各條件缺少的鍵，與從 API 載入的路徑一致
      vm.initConditions()
      vm.notifySettingType = 'custom'
    },
    // changeSliderNotifyRespiration(vale) {
    //   this.notifyModalData.notify_respiration_min = vale[0]
    //   this.notifyModalData.notify_respiration_max = vale[1]
    // },
    changeSliderNotifyHeartRate (vale) {
      this.notifyModalData.notify_heartRate_min = vale[0]
      this.notifyModalData.notify_heartRate_max = vale[1]
    },
    changeSliderNotifyTemp (vale) {
      this.notifyModalData.notify_temp_min = vale[0]
      this.notifyModalData.notify_temp_max = vale[1]
    },
    addExcludeTime () {
      this.notifyModalData.exclude_range.push({
        started_at: null,
        ended_at: null
      })
    },
    delExcludeTime (index) {
      this.notifyModalData.exclude_range.splice(index, 1)
    },
    minutesToSeconds (time) {
      return time * 60
    },
    secondsToMinutes (time) {
      return time / 60
    },
    toEditThisTemplate (id) {
      const routeUrl = this.$router.resolve({
        name: 'NotifyTemplate',
        params: { id: id }
      })
      window.open(routeUrl.href, '_blank')
    },
    addModal () {
      this.is_edit = false
      this.editResidentForm.name = null
      this.editResidentForm.birthday = ''
      this.editResidentForm.gender = null
      this.editResidentForm.id_number = null
      this.editResidentForm.note = null
      this.editResidentForm.usage_venue = null
      this.editResidentForm.usage_venue_select = null
      this.editResidentForm.usage_venue_custom = ''
      this.editResidentForm.resident_type = null
      this.editResidentForm.resident_type_other = null
      this.editResidentForm.emergency_contacts = [{ name: '', phone: '', relation: '' }, { name: '', phone: '', relation: '' }]
      this.$nextTick(function () {
        this.bootstrap_modal = new Modal(this.$refs.modal)
        this.bootstrap_modal.show()
      })
    },
    editModal (id) {
      this.is_edit = true
      this.edit_id = id
      this.items.forEach((ele) => {
        if (ele.id === id) {
          this.editResidentForm.name = ele.name
          this.editResidentForm.age = ele.age
          this.editResidentForm.birthday = ele.birthday
          this.editResidentForm.gender = ele.gender
          this.editResidentForm.id_number = ele.id_number
          this.editResidentForm.note = ele.note
          this.editResidentForm.usage_venue = ele.usage_venue
          const presets = ['醫院', '社區(輔具中心)', '社區(日照中心)']
          if (!ele.usage_venue || presets.includes(ele.usage_venue)) {
            this.editResidentForm.usage_venue_select = ele.usage_venue
            this.editResidentForm.usage_venue_custom = ''
          } else {
            this.editResidentForm.usage_venue_select = '__custom__'
            this.editResidentForm.usage_venue_custom = ele.usage_venue
          }
          this.editResidentForm.resident_type = ele.resident_type
          this.editResidentForm.resident_type_other = ele.resident_type_other
          this.editResidentForm.emergency_contacts =
            Array.isArray(ele.emergency_contacts) && ele.emergency_contacts.length > 0
              ? (ele.emergency_contacts.length === 1
                ? [...JSON.parse(JSON.stringify(ele.emergency_contacts)), { name: '', phone: '' }]
                : JSON.parse(JSON.stringify(ele.emergency_contacts)))
              : [{ name: '', phone: '' }, { name: '', phone: '' }]
        }
      })
      this.$nextTick(function () {
        this.bootstrap_modal = new Modal(this.$refs.modal)
        this.bootstrap_modal.show()
      })
    },
    onUsageVenueChange () {
      if (this.editResidentForm.usage_venue_select === '__custom__') {
        this.editResidentForm.usage_venue = this.editResidentForm.usage_venue_custom || null
      } else {
        this.editResidentForm.usage_venue = this.editResidentForm.usage_venue_select
        this.editResidentForm.usage_venue_custom = ''
      }
    },
    submitResidentForm () {
      const vm = this

      if (vm.editResidentForm.usage_venue_select === '__custom__') {
        vm.editResidentForm.usage_venue = vm.editResidentForm.usage_venue_custom || null
      } else {
        vm.editResidentForm.usage_venue = vm.editResidentForm.usage_venue_select
      }

      if (!vm.validateEmergencyContacts()) {
        vm.AlertsInfo({
          state: 'error',
          title: i18n.t('__error'),
          info: i18n.t('__validateEmergencyContactsError')
        })
        vm.Alerted()
        return
      }

      if (vm.is_edit) {
        console.log(this.editResidentForm)
        resident.update(vm.edit_id, this.editResidentForm, vm.token).then((res) => {
          if (res.status <= 201 && res.data.status === 'success') {
            vm.getResidents()
            vm.AlertsInfo({
              state: 'success',
              title: i18n.t('__success'),
              info: i18n.t('__editSuccess')
            })
            vm.Alerted()
            vm.bootstrap_modal.hide()
          } else {
            vm.AlertsInfo({
              state: 'error',
              title: i18n.t('__error'),
              info: res.data.errMsg.toString()
            })
            vm.Alerted()
          }
          vm.Loaded()
        })
      } else {
        resident.create(this.editResidentForm, vm.token).then((res) => {
          if (res.status <= 201 && res.data.status === 'success') {
            vm.getResidents()
            vm.AlertsInfo({
              state: 'success',
              title: i18n.t('__success'),
              info: i18n.t('__addSuccess')
            })
            vm.Alerted()
            vm.bootstrap_modal.hide()
          } else {
            vm.AlertsInfo({
              state: 'error',
              title: i18n.t('__error'),
              info: res.data.errMsg.toString()
            })
            vm.Alerted()
            vm.validate = res.data.validate
          }
          vm.Loaded()
        })
      }
    },
    deleteAlert (id) {
      const vm = this
      vm.edit_id = id
      this.items.forEach((ele) => {
        if (ele.id === id) {
          this.editResidentForm.name = ele.name
        }
      })
      vm.bootstrap_modal = new Modal(vm.$refs.deleteModal)
      vm.bootstrap_modal.show()
    },
    deleteResident (id) {
      const vm = this
      vm.bootstrap_modal.hide()
      resident.delete(id, vm.token).then((res) => {
        if (res.status <= 201 && res.data.status === 'success') {
          vm.getResidents()
          vm.AlertsInfo({
            state: 'success',
            title: i18n.t('__success'),
            info: i18n.t('__deleteSuccess')
          })
          vm.Alerted()
          vm.bootstrap_modal.hide()
        } else {
          vm.AlertsInfo({
            state: 'error',
            title: i18n.t('__error'),
            info: res.data.errMsg.toString()
          })
          vm.Alerted()
        }
        vm.Loaded()
      })
    },
    initBootstrapTab () {
      const vm = this
      if (vm.notifySettingType === 'template' && vm.$refs.templateList) {
        vm.bootstrap_template_tab = []
        const triggerTabList = [].slice.call(
          vm.$refs.templateList.querySelectorAll('button')
        )
        triggerTabList.forEach(function (triggerEl, index) {
          vm.bootstrap_template_tab.push(new Tab(triggerEl))
          triggerEl.addEventListener('click', function (event) {
            event.preventDefault()
            vm.bootstrap_template_tab[index].show()
          })
        })
        vm.bootstrap_template_tab[0].show()
      } else if (vm.notifySettingType === 'custom' && vm.$refs.customList) {
        vm.bootstrap_custom_tab = []
        const triggerTabList = [].slice.call(
          vm.$refs.customList.querySelectorAll('button')
        )
        triggerTabList.forEach(function (triggerEl, index) {
          vm.bootstrap_custom_tab.push(new Tab(triggerEl))
          triggerEl.addEventListener('click', function (event) {
            event.preventDefault()
            vm.bootstrap_custom_tab[index].show()
          })
        })
        vm.bootstrap_custom_tab[0].show()
      }
    },
    initBootstrapTooltip () {
      const vm = this
      vm.$nextTick(function () {
        const delay = { show: 200, hide: 200 }
        vm.bootstrap_tooltip = [].slice
          .call(document.querySelectorAll('[data-bs-toggle="tooltip"]'))
          .map(function (tooltipTriggerEl) {
            return new Tooltip(tooltipTriggerEl, {
              trigger: (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) ? 'manual' : 'hover',
              delay: delay
            })
          })
      })
    },
    addNotifyLeaveCondition () {
      this.notifyModalData.notify_leave_conditions.push({ action: true, timeout_max: 900, type: 'normal', call_category: 'immediate' })
    },
    delNotifyLeaveCondition (i) {
      const arr = this.notifyModalData.notify_leave_conditions.splice(i, 1)
      if (arr.length <= 1) return
      arr.slice(i, 1)
    },
    addNotifyLyingCondition () {
      this.notifyModalData.notify_lying_conditions.push({ max: 7800, type: 'normal', call_category: 'immediate' })
    },
    delNotifyLyingCondition (i) {
      const arr = this.notifyModalData.notify_lying_conditions.splice(i, 1)
      if (arr.length <= 1) return
      arr.slice(i, 1)
    },
    // 呼吸率
    addNotifyRespirationCondition () {
      this.notifyModalData.notify_respiration_conditions.push({
        min: 12,
        max: 26,
        duration: 600,
        type: 'normal',
        call_category: 'immediate'
      })
    },
    delNotifyRespirationCondition (i) {
      const arr = this.notifyModalData.notify_respiration_conditions.splice(i, 1)
      if (arr.length <= 1) return
      arr.slice(i, 1)
    },
    changeSliderNotifyRespiration (i, [min, max]) {
      Object.assign(this.notifyModalData.notify_respiration_conditions[i], { min, max })
    },
    addNotifyRestlessCondition () {
      this.notifyModalData.notify_restless_conditions.push({
        max: 60,
        duration: 300,
        type: 'normal',
        call_category: 'immediate'
      })
    },
    delNotifyRestlessCondition (i) {
      const arr = this.notifyModalData.notify_restless_conditions.splice(i, 1)
      if (arr.length <= 1) return
      arr.slice(i, 1)
    },
    addNotifyHeartRateCondition () {
      this.notifyModalData.notify_heartRate_conditions.push({
        min: 50,
        max: 100,
        duration: 600,
        type: 'normal',
        call_category: 'immediate'
      })
    },
    delNotifyHeartRateCondition (i) {
      const arr = this.notifyModalData.notify_heartRate_conditions.splice(i, 1)
      if (arr.length <= 1) return
      arr.slice(i, 1)
    },
    changeHeartRateCondition (i, [min, max]) {
      Object.assign(this.notifyModalData.notify_heartRate_conditions[i], { min, max })
    },
    initConditions () {
      const d = this.notifyModalData

      // 離床
      if (!Array.isArray(d.notify_leave_conditions) || d.notify_leave_conditions.length === 0) {
        this.$set(d, 'notify_leave_conditions', [{
          action: d.notify_leave_action,
          timeout_max: d.notify_leave_timeout_max || 900,
          type: 'normal'
        }])
      }

      // 躺床
      if (!Array.isArray(d.notify_lying_conditions) || d.notify_lying_conditions.length === 0) {
        this.$set(d, 'notify_lying_conditions', [{
          max: d.notify_lying_max || 7800,
          type: 'normal'
        }])
      }

      // 呼吸
      if (!Array.isArray(d.notify_respiration_conditions) || d.notify_respiration_conditions.length === 0) {
        this.$set(d, 'notify_respiration_conditions', [{
          min: d.notify_respiration_min || 12,
          max: d.notify_respiration_max || 26,
          duration: d.notify_respiration_duration || 600,
          type: 'normal'
        }])
      }

      // 躁動
      if (!Array.isArray(d.notify_restless_conditions) || d.notify_restless_conditions.length === 0) {
        this.$set(d, 'notify_restless_conditions', [{
          max: d.notify_restless_max,
          duration: d.notify_restless_duration || 300,
          type: 'normal'
        }])
      }

      // 心跳
      if (!Array.isArray(d.notify_heartRate_conditions) || d.notify_heartRate_conditions.length === 0) {
        this.$set(d, 'notify_heartRate_conditions', [{
          min: d.notify_heartRate_min || 50,
          max: d.notify_heartRate_max || 100,
          duration: d.notify_heartRate_duration || 600,
          type: 'normal'
        }])
      }

      if (!Array.isArray(d.notify_combo_conditions) || d.notify_combo_conditions.length === 0) {
        this.$set(d, 'notify_combo_conditions', [
          { key: 'low_hr_low_rr', enabled: false, type: 'emergency', label: this.$t('__lowHeartRateLowRespiratory') },
          { key: 'high_hr_high_rr', enabled: false, type: 'emergency', label: this.$t('__highHeartRateHighRespiratory') },
          { key: 'high_hr_low_rr', enabled: false, type: 'emergency', label: this.$t('__highHeartRateLowRespiratory') },
          { key: 'low_hr_high_rr', enabled: false, type: 'emergency', label: this.$t('__lowHeartRateHighRespiratory') }
        ])
      }

      // 過度躺床
      if (!Array.isArray(d.overbedding_conditions) || d.overbedding_conditions.length === 0) {
        const mode = d.overbedding_mode || 'continuous'
        const maxSec = d.overbedding_threshold_hours ? Math.round(d.overbedding_threshold_hours * 3600) : 7200
        this.$set(d, 'overbedding_conditions', [{ mode: mode, max: maxSec, type: 'normal', notify_once: false }])
      }
      // 既有資料的條件可能沒有 notify_once 鍵，補上才有響應式
      d.overbedding_conditions.forEach(c => {
        if (typeof c.notify_once === 'undefined') {
          this.$set(c, 'notify_once', false)
        }
      })
    },
    addOverBeddingCondition () {
      this.notifyModalData.overbedding_conditions.push({ mode: 'continuous', max: 7200, type: 'normal', notify_once: false, call_category: 'immediate' })
    },
    delOverBeddingCondition (i) {
      this.notifyModalData.overbedding_conditions.splice(i, 1)
    },
    addEmergencyContact () {
      this.editResidentForm.emergency_contacts.push({ name: '', phone: '', relation: '' })
    },
    delEmergencyContact (i) {
      this.editResidentForm.emergency_contacts.splice(i, 1)
    },
    validateEmergencyContacts () {
      const contacts = this.editResidentForm.emergency_contacts || []
      for (let i = 0; i < contacts.length; i++) {
        const c = contacts[i]
        // 只要有一欄有填，就都必須填
        if ((c.name || c.phone) && (!c.name || !c.phone)) {
          return false // 驗證失敗
        }
      }
      return true // 驗證通過
    },
    formatPhoneNumber (phone) {
      // 格式化電話號碼：0281920003 -> (02)819-20003
      if (!phone || phone.length !== 10) return phone

      // 假設是 02 開頭的電話
      if (phone.startsWith('02')) {
        return `(02)${phone.substring(2, 5)}-${phone.substring(5)}`
      }

      // 其他區碼或手機號碼的格式化可以在此擴充
      return phone
    },
    handleResidentTypeChange () {
      // 如果不是選擇「其他」，清空其他說明欄位
      if (this.editResidentForm.resident_type !== '其他') {
        this.editResidentForm.resident_type_other = null
      }
    },
    handleLeaveWarningEmergency () {
      // 如果點擊了緊急選項，確保也勾選了對應的主通知選項
      if (this.notifyModalData.notify_leave_warning_type !== 'emergency') {
        this.notifyModalData.notify_leave_warning = true
      }
      // 切換緊急/一般狀態
      this.notifyModalData.notify_leave_warning_type = this.notifyModalData.notify_leave_warning_type === 'emergency' ? 'normal' : 'emergency'
    },
    handleSittingInsufficientEmergency () {
      // 如果點擊了緊急選項，確保也勾選了對應的主通知選項
      if (this.notifyModalData.notify_sitting_insufficient_type !== 'emergency') {
        this.notifyModalData.notify_sitting_insufficient = true
      }
      // 切換緊急/一般狀態
      this.notifyModalData.notify_sitting_insufficient_type = this.notifyModalData.notify_sitting_insufficient_type === 'emergency' ? 'normal' : 'emergency'
    },
    clickNotifyLeaveWarning () {
      if (!this.notifyModalData.notify_leave_warning) {
        this.notifyModalData.notify_leave_warning_type = 'normal'
      }
    },
    clickNotifySittingInsufficient () {
      if (!this.notifyModalData.notify_sitting_insufficient) {
        this.notifyModalData.notify_sitting_insufficient_type = 'normal'
      }
    }
  },
  created () {
  },
  mounted () {
    console.log('userInfo:', this.userInfo)

    if (this.userInfo) {
      this.getResidents()
      this.getNotify()
      this.getEmergencyCallNumbers()
      this.getInstitutionSleepTime()
    }
  }
}
</script>

<style lang="scss">
#notify {
  .modal-content {
    background-color: #f3f3f3;
  }
}

.custom-tab-check {
  .form-check {
    position: relative;
    width: 105px;
    height: 34px;
    margin-bottom: 20px;

    &-input {
      opacity: 0;

      &:checked + .form-check-label {
        background-color: $primary;
        color: #fff;

        &::after {
          content: '';
          position: absolute;
          bottom: 0;
          left: 50%;
          transform: translate(-50%, 90%);
          width: 0;
          height: 0;
          border-style: solid;
          border-width: 10px 5px 0 5px;
          border-color: $primary transparent transparent transparent;
        }
      }
    }

    &-label {
      position: absolute;
      left: 0;
      top: 0;
      width: 100%;
      padding: 5px 0;
      text-align: center;
      background-color: #fff;
      border-radius: 5px 0 0 5px;
    }

    &:last-child {
      .form-check-label {
        border-radius: 0 5px 5px 0;
      }
    }
  }
}

.slider-connect {
  background: $primary;
}

.slider-tooltip {
  border: 1px solid $dark;
  background: $dark;
}

.resident .icon {
  width: 20px;
}

.custom-radio {
  position: relative;
  display: inline-block;
  width: 20px;
  height: 20px;
  cursor: pointer;
}
.custom-radio input[type="radio"] {
  opacity: 0;
  width: 0;
  height: 0;
  margin: 0;
  position: absolute;
}
.custom-radio span {
  display: block;
  width: 20px;
  height: 20px;
  border-radius: 50%;
  border: 2px solid #ccc;
  background: transparent;
  transition: border-color 0.2s, background 0.2s;
}
.radio-yellow span {
  border-color: #ffc107;
}
.radio-red span {
  border-color: #dc3545;
}
.custom-radio input[type="radio"]:checked + span {
  background: currentColor;
  border-color: currentColor;
}
.radio-yellow input[type="radio"]:checked + span {
  color: #ffc107;
}
.radio-red input[type="radio"]:checked + span {
  color: #dc3545;
}
</style>
